<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs fixed-tabs dark :background-color="`${buttonColor}`" v-model="tab">
            <v-tab>{{ $t("registerEvent.registration") }}</v-tab>
            <v-tab :disabled="!bShowDescription" @click="getEventDescription">{{ $t("registerEvent.description")
              }}</v-tab>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters class="mb-4">
      <v-col cols="12" class="px-2 pb-2">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <!-- datatable riders -->
            <v-row>
              <v-col></v-col>
            </v-row>
            <v-row>
              <v-col md="12" sm="12" cols="12">
                <p class="mb-0">{{ $t(`registerEvent.step3_description_1`) }}</p>
                <p class="mb-0">{{ $t(`registerEvent.step3_description_2`) }}</p>
              </v-col>
              <v-col md="12" sm="12" cols="12" class="pb-0">
                <v-btn v-if="registrationObj.eventSel != null && registrationObj.eventSel.isSpectatorRegistration == 0"
                  :color="`${buttonColor}`" class="btn_next my-1 mr-4" @click="addRider">{{ $tc("registerEvent.add_part") }}</v-btn>
                <v-btn v-if="emergencyContactAll" :color="`${buttonColor}`" class="btn_next mr-4 my-1"
                  @click="addEmergencyContact">{{ $t("registerEvent.add_emergency_contact") }}</v-btn>
                <v-btn v-if="isMembershipRequired" :color="`${buttonColor}`" class="btn_next mr-4 my-1" v-model="step"
                  @click="setShowMembershipDialog">{{ $tc("registerEvent.add_membership") }}</v-btn>
                <v-btn v-if="signedEventWaiverAll" :color="`${buttonColor}`" class="btn_next mr-4 my-1"
                  @click="addSignedEventWaiver">{{ $t("registerEvent.sign_event_waiver") }}</v-btn>
              </v-col>
              <v-col md="12" sm="12">
                <v-data-table 
                  :key="key" 
                  :headers="ridersHeaders" 
                  :items="participantsSel" 
                  :options="{itemsPerPage:-1}"
                  sort-by="name" 
                  class="elevation-1 dt_part" 
                  item-key="firstName" 
                  :item-class="rowClass" 
                  dense
                  :footer-props="{
                    'items-per-page-text': $t('dataTable.rowsPerPageText'),
                    'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                  }"
                  :no-data-text="$t('dataTable.noDataText')"
                  :headerProps="{
                    'sort-by-text': $t('dataTable.sortByText')
                  }"
                >

                  <template v-slot:header.selected="">
                    <v-checkbox @change="updateAllChecks($event)" v-model="allCheck"></v-checkbox>
                  </template>
                  <template v-slot:[`item.selected`]="{ item }">
                    <v-checkbox :disabled="item.disabled || item.disabledStatus" v-model="item.selected"
                      @change="updateCheck($event, item.userId)"></v-checkbox>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <span v-if="item.disabled"
                      :style="`${item.statusColor != '' ? `color: ${item.statusColor}` : ''};`">{{ item.status }}</span>
                    <template v-else>{{ item.status }}</template>
                  </template>
                  <template v-slot:[`item.emergencyContact`]="{ item }">
                    <div v-if="!item.emergencyContact || !item.birthday">
                      <v-icon @click="setAccountStatusDialog(item)">far fa-question-circle</v-icon>
                      <span style="color:red; cursor: pointer;" class="ml-2" @click="setAccountStatusDialog(item)">
                        <span v-if="!item.birthday">{{ $tc("riders.birthday_missing") }}</span>
                        <span v-if="!item.emergencyContact">{{ $tc("riders.emergency_contact_missing") }}</span>
                      </span>
                    </div>
                    <div v-if="item.emergencyContact && item.birthday" class=" d-flex justify-center align-center">
                      <v-icon color="green">fas fa-check-circle</v-icon>
                    </div>
                  </template>
                  <template v-slot:[`item.eventWaiver`]="{ item }">
                    <v-icon 
                      v-if="item.eventWaiver == 'NotSigned' || item.eventWaiver == 'Not Signed' || item.eventWaiver == 'Rejected'" 
                      @click="getEventWaivers(item)"
                    >
                      far fa-question-circle
                    </v-icon>
                    <span 
                      :style="`${item.colorEventWaiver ? 'color: red; cursor: pointer;' : ''}`" 
                      @click="getEventWaivers(item)"
                    >
                      {{ (item.eventWaiver && item.eventWaiver != "") ? (
                          (item.eventWaiver == 'NotSigned' || item.eventWaiver == 'Not Signed') ? $t("common.NotSigned") : (
                            (item.eventWaiver == 'Rejected') ? $t("common.Rejected") : $t("common.Signed")
                          )
                        ) : "" }}
                    </span>
                  </template>
                  <template v-if="isMembership" v-slot:[`item.membership`]="{ item }">
                    <span v-if="item.membershipColor">
                      <v-icon @click="setShowMembershipDialog">far fa-question-circle</v-icon>
                      <span style="color:red; cursor: pointer;" @click="setShowMembershipDialog">
                        {{ $t(`registerEvent.${item.membership}`) }}
                      </span>
                    </span>
                    <span v-else>{{ $t(`registerEvent.${item.membership}`) }}</span>
                  </template>
                  <!-- Waiver signature required -->
                  <template v-if="isMembership" v-slot:[`item.waivers`]="{ item }">
                    <span v-if="item.waiversColor" style="color:red;">
                      <v-tooltip v-if="item.requiresRelatedOrgWaiver && (item.missingForcedOrgWaivers || []).length" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon @click="getMembershipWaivers(item)">far fa-question-circle</v-icon>
                    </span>
                        </template>
                          <span>{{ $t('registerEvent.waiver_related_organization_tooltip') }}</span>
                      </v-tooltip>
                        <v-icon v-else @click="getMembershipWaivers(item)">far fa-question-circle</v-icon>
                        {{ getWaiverLabel(item) }}
                    </span>
                    <span v-else-if="item.waiverSigned" style="color: green;">
                      <v-icon color="green" small>fas fa-check-circle</v-icon>
                      {{ $t('registerEvent.waiver_signed') }}
                    </span>
                    <span v-else>{{ getWaiverLabel(item) }}</span>
                  </template>
                  <template v-if="registrationObj.eventSel && registrationObj.eventSel.isMultiReg == 1"
                    v-slot:[`item.classes`]="{ item }">
                    <span v-if="item.classesColor" style="color:red;">{{ item.classes }}</span>
                    <span v-else>{{ item.classes }}</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <DescriptionEvent :eventDescription="eventDescription" :registrationObj="registrationObj" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn :color="`${buttonColor}`" class="btn_next my-1" v-model="step" @click="nextStep(stepBack);">{{
            $t("registerEvent.prev") }}</v-btn>
      </v-col>
      <v-col cols="6" v-if="tab == 0">
        <v-btn :color="`${buttonColor}`" class="btn_next my-1 float-right" v-model="step" @click="validateRiders"
          :disabled="disabledForNotOpen" :loading="loading">
          {{ textForBtnNext }}
        </v-btn>
      </v-col>
    </v-row>

    <div id="framefixerextreme" style="height: 0 !important;">
      <v-app id="inspire" style="height: 0 !important;">
        <v-row justify="center">
          <v-dialog v-model="waiverModal" persistent width="unset">

            <v-card ref="waiverModalParticipant">
              <v-card-text class="px-sm-6 px-0">
                <WaiverEvent ref="waiverEvent" :waivers="waiverE" :registrationObj="registrationObj"
                  @nextSignItem="nextSignItem" />
              </v-card-text>

            </v-card>
          </v-dialog>
          <v-dialog v-model="membershipWaiverModal" persistent width="unset">
            <v-card ref="membershipWaiverModalParticipant">
              <v-card-text class="px-sm-6 px-0">
                <WaiverOrg
                  ref="membershipWaiverEvent"
                  :waivers="membershipWaiverE ? [membershipWaiverE] : []"
                  @nextSignItem="nextMembershipSignItem"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="waiverOrgModal" persistent width="unset">
            <v-card>
              <v-card-text class="px-sm-6 px-0">
                <WaiverOrg :waivers="waiverOrg" @nextSignItem="nextSignOrgItem" />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-app>
    </div>

    <v-dialog v-model="alertQuestion" max-width="700px">
      <v-card>
        <v-card-title>{{ $t("common.warning") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text--primary">
          {{ $t("eventWaiver.alert_racer_or_participant") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="buttonColor" @click="alertQuestion = false" class="white--text mx-1">{{ $t("common.cancel")
            }}</v-btn>
          <v-btn :color="buttonColor" class="white--text mx-1" @click="confirm('Spectator')">
            {{ $t("eventWaiver.alert_spectator") }}
          </v-btn>
          <v-btn :color="buttonColor" class="white--text mx-1" @click="confirm('Participant')">
            {{ $t("eventWaiver.alert_participant") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="membershipRequiredDialog" width="650" max-width="90vw">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("registerEvent.membership_information") }}
        </v-card-title>
        <v-card-text style="max-height: 80vh; overflow-y: auto;">
          <v-row>
            <v-col cols="12">{{ $t("registerEvent.membership_information_message") }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pa-0">
              <v-expansion-panels v-model="panelMemberships">
                <v-expansion-panel 
                  v-for="(eventOrganization) in eventOrganizations" 
                  :key="eventOrganization.organizationId"
                >
                  <v-expansion-panel-header>
                    <span class="org-name">{{ eventOrganization.name }}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>                      
                      <v-col cols="12" v-if="eventOrganization.allowSignup == 1">
                        <div class="card_new_items">
                          <div v-for="membershipPrice in eventOrganization.membershipPrices" :key="membershipPrice.membershipTypeId">                          
                            <div class="new_card">
                              <div class="d-flex justify-space-between">
                                <span>{{ membershipPrice.name }}</span>
                                <span class="text-right red--text">{{ membershipPrice.price === 0 ? $t("registerEvent.membership_free") : '$' + membershipPrice.price }}</span>
                </div>
                              <div class="subtitle_card">
                                <span>{{ membershipPrice.description }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" class="text-right pt-0"  v-if="eventOrganization.allowSignup == 1">
                        <v-btn color="primary" small elevation="2"
                          @click="becomeAMember(eventOrganization.organizationId)">
                    {{ $tc("registerEvent.signup_for") }}
                  </v-btn>
                      </v-col>
                      <v-col cols="12" class="pa-0" v-if="eventOrganization.allowSignup == 0">
                        <p class="mb-0 error_msg">
                    {{ $t("registerEvent.organization_allow_signup") }}
                        </p>
            </v-col>
          </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>            
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="membershipRequiredDialog = false">
            {{ $t('common.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="amaDialog" width="auto" max-width="700px">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ modalTitle }}
        </v-card-title>
        <v-card-text>          
          <v-row>
            <v-col cols="12" v-if="requireAmaD14Dialog">
              <p class="mb-0">{{ $tc("registerEvent.require_ama_d14_message_1") }} 
                <b>{{ registrationObj.eventSel && registrationObj.eventSel.eventDate ? registrationObj.eventSel.eventDate : '' }}</b>.
              </p>
              <p class="mb-0 text-danger">{{ $tc("registerEvent.require_d14_ama_message_2") }}</p>
            </v-col>
          </v-row>      
          <v-row>
            <v-col cols="12" v-if="requireAmaDialog">
              <p class="mb-0">{{ $tc("registerEvent.require_ama_message_1") }} 
                <b>{{ dateEventRequired }}</b>.</p>
              <p class="text-danger">{{ $tc("registerEvent.require_ama_message_2") }}</p>
              <p class="mb-0" v-html="$tc('registerEvent.ama_membership_available')"></p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-for="participant in partSel" :key="participant.userId">
              <v-card>
                <v-card-title>{{ participant.fName }} {{ participant.lName }}</v-card-title>

                <v-card-text v-if="requireAmaDialog && !participant.showAmaInfo">
                  <v-text-field v-model="participant.amaMembership" :label="$tc('registerEvent.membership_number_label')" :disabled="participant.amaStatus" outlined dense required hide-details />
                  <p v-if="participant.amaErrorMsg" class="error-message mb-0" :style="{ color: participant.amaColorMessage || '#ff0000' }" v-html="participant.amaErrorMsg"></p>
                  <v-btn color="primary" elevation="2" class="mt-2" @click="validateAMA(participant, 'ama')" :disabled="participant.amaStatus" :loading="participant.amaLoading">
                    {{ $tc("registerEvent.validate_ama") }}
                  </v-btn>
                </v-card-text>

                <v-card-text v-if="requireAmaD14Dialog && !participant.showAmaInfo">
                  <v-text-field v-model="participant.amaD14Membership" :label="$tc('registerEvent.membership_number_label')" :disabled="participant.amaD14Status" outlined dense required hide-details />
                  <p v-if="participant.amaErrorMsg" class="error-message mb-0" :style="{ color: participant.amaColorMessage || '#ff0000' }" v-html="participant.amaErrorMsg"></p>
                  <v-btn color="primary" elevation="2" @click="validateAMA(participant, 'd14')" :disabled="participant.amaD14Status" :loading="participant.amaLoading" class="mt-2">
                    {{ $tc("registerEvent.validate_ama_d14") }}
                  </v-btn>
                </v-card-text>

                <v-card-text v-if="participant.showAmaInfo">
                  <v-row>
                    <v-col cols="12" class="py-0">
                      <p class="mb-0">{{ $tc('membership.ama_profile_difference') }}</p>
                    </v-col>
                    <v-col cols="12">
                      <h3 class="mb-1">{{ $tc('membership.information_comparison') }}</h3>
                      <v-data-table
                        dense
                        :headers="amaComparisonHeaders"
                        hide-default-footer
                        :items="participant.membershipResponseItems || []"
                      ></v-data-table>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <div class="warning-box">
                        <h3 class="mb-1 d-flex align-center">
                          <v-icon left color="warning" class="warning-icon mr-2">mdi-alert</v-icon>
                          {{ $tc('membership.notice') }}
                        </h3>
                        <p class="mb-0 d-flex align-center" v-html="$tc('membership.notice_content')"></p>
                      </div>
                    </v-col>
                    <v-col cols="12" class="mb-0 pb-0" v-if="isParticipantOwner(participant)">
                      <v-btn :color="buttonColor" class="btn-responsive white--text" :loading="participant.amaLoading" @click="goToProfileAMA()">
                        {{ $tc('membership.btn_update_ama_information') }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="pb-0" v-if="isParticipantOwner(participant)">
                      <v-btn :color="buttonColor" class="btn-responsive white--text" :loading="participant.amaLoading" @click="updateAmaProfile(participant)">
                        {{ $tc('membership.btn_update_livelaps_account_to_match_ama') }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12" class="pb-0" v-if="isParticipantAccountManager(participant) && !isParticipantOwner(participant)">
                      <v-alert type="error" dense outlined class="mb-0 font-weight-bold" style="color: #ff0000 !important; border-color: #ff0000 !important;">
                        {{ $tc('membership.mismatch_action_managed') }}
                      </v-alert>
                    </v-col>
                    <v-col cols="12" class="pb-0" v-if="!isParticipantAccountManager(participant)">
                      <v-alert type="error" dense outlined class="mb-0 font-weight-bold" style="color: #ff0000 !important; border-color: #ff0000 !important;">
                        {{ $tc('membership.mismatch_action_other') }}
                      </v-alert>
                    </v-col>
                    <v-col cols="12">
                      <v-btn color="error" class="btn-responsive white--text" :loading="participant.amaLoading" @click="resetParticipantAmaInfo(participant)">
                        {{ $tc('membership.cancel') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeAmaDialog()">
            {{ $tc("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <WaiverDialog 
      ref="waiverDialog" 
      :promoterName="promoterName" 
      :role="role" 
      :waiverDialog="waiverRequiredDialog && waiverDialogType === 'event'"
      :bSend="bSendWaiver" 
      @changeField="changeField" 
      @showAlert="(v) => $emit('showAlert', v)"
      @alertNotValidate="(v) => $emit('alertNotValidate', v)" 
      @addWaiver="addWaiver" 
      @refreshWaiverStatus="handleRefreshWaiverStatus" 
      componentFather="StepParticipant"
    />
    <ParentGuardianDialog
      v-model="parentGuardianDialogOpen"
      :adultId="userStore && userStore.id ? userStore.id : 0"
      :minor="parentGuardianDialogMinor"
      :buttonColor="buttonColor"
      @confirmed="onParentGuardianConfirmed"
      @blocked="onParentGuardianBlocked"
    />
    <MembershipWaiverDialog
      ref="membershipWaiverDialog"
      :role="role"
      :selectedParticipant="itemSelected"
      :selectedParticipantIsMinor="itemSelectedIsMinor"
      :isAccountManagerForParticipant="isAccountManagerForSelectedParticipant"
      :waiverDialog="waiverRequiredDialog && waiverDialogType === 'membership'"
      :bSend="bSendWaiver"
      @changeField="changeField"
      @refreshMembershipWaiverStatus="handleRefreshMembershipWaiverStatus"
      @showAlert="(v) => $emit('showAlert', v)"
      @alertNotValidate="(v) => $emit('alertNotValidate', v)"
      @addMembershipWaiver="addMembershipWaiver"
      componentFather="StepParticipant"
    />
    <v-dialog v-model="accountStatusDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("riders.account_status_title") }}
        </v-card-title>

        <v-card-text class="py-2">
          <span>
            {{ $t("riders.account_status_message") }}
          </span>

          <div class="py-4" v-if="item && !item.emergencyContact">
            <v-card>
              <v-card-title class="text-h5 lighten-2">
                {{ $t("riders.account_status_emergency_contact_title") }}
              </v-card-title>
              <v-card-text>{{ $t("riders.account_status_emergency_contact") }}</v-card-text>
            </v-card>
          </div>

          <div class="py-4" v-if="item && !item.birthday">
            <v-card>
              <v-card-title class="text-h5 lighten-2">
                {{ $t("riders.account_status_birthday_title") }}
              </v-card-title>
              <v-card-text>{{ $t("riders.account_status_birthday") }}</v-card-text>
            </v-card>
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeAccountStatusDialog()">
            {{ $t("riders.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import
  {
    VRow, VCol, VBtn, VDataTable, VDialog, VIcon, VCheckbox, VCard, VCardTitle, VCardText, VDivider, VSpacer, VCardActions,
    VTabs, VTab, VTabItem, VTabsItems, VApp, VTextField, VExpansionPanels, 
    VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VTooltip
  } from 'vuetify/lib';
import RegistrationService from '@/services/RegistrationService';
import LocalStorageService from "@/services/LocalStorageService";
import moment from 'moment-timezone';
import EventWaiverService from "@/services/EventWaiverService";
import OrganizationService from "@/services/OrganizationService";
import AMAService from "@/services/AMAService";
import MembershipService from "@/services/MembershipService";
import MembershipWaiverService from "@/services/MembershipWaiverService";
import WaiverEvent from "@/components/waiver/WaiverEventSpectator";
import WaiverOrg from "@/components/waiverOrganization/WaiverOrg";
import DescriptionEvent from "@/components/eventRegistration/DescriptionEvent";
import WaiverDialog from "@/components/eventRegistration/components/WaiverDialog";
import MembershipWaiverDialog from "@/components/eventRegistration/components/MembershipWaiverDialog";
import ParentGuardianDialog from "@/components/memberRegistration/ParentGuardianDialog.vue";
import { mapState } from 'vuex';
import APIService from "@/services/APIService";
import WaiverService from "@/services/WaiverService";
import ProfileService from "@/services/ProfileService";
import { formatDateForHumans } from "@/helpers/date-helper";

export default {
  components: {
    VRow, VCol, VBtn, VDataTable, VIcon, VCheckbox, VDialog, VCard, VCardTitle, VCardText, VDivider, VSpacer, VCardActions, VTabs, VTab, VApp,
    WaiverEvent, WaiverOrg, VTabItem, VTabsItems, DescriptionEvent, WaiverDialog, MembershipWaiverDialog, ParentGuardianDialog, VTextField, VExpansionPanels,
    VExpansionPanel, VExpansionPanelHeader, VExpansionPanelContent, VTooltip
  },
  props: {
    step: Number, registrationObj: Object, isMembership: Boolean,
    isVehicles: Boolean, isSponsors: Boolean, disabledStep3: Boolean, itemOrg: Object,
    eventDescription: String, stepperCounts: Number
  },
  data()
  {
    return {
      buttonColor: "#000",
      key: 0,
      alertQuestion: false,
      waiverModal: false,
      membershipWaiverModal: false,
      waiverOrgModal: false,
      waiverE: {},
      membershipWaiverE: {},
      waiverOrg: [],
      tab: 0,
      waiverEArray: [],
      membershipWaiverEArray: [],
      selectedSigWaiver: [],
      resetWaiver: false,
      resetMembershipWaiver: false,
      membershipRequiredDialog: false,
      requireAmaDialog: false,
      requireAmaD14Dialog: false,
      amaDialog: false,
      eventOrganizations: [],
      itemSelected: null,
      itemSelectedIsMinor: null,
      role: 'Participant',
      waiverRequiredDialog: false,
      disableWaiverRefresh: false,
      bSendWaiver: false,
      accountStatusDialog: false,
      item: null,
      loading: false,
      allCheck: false,
      internalDialogVisible: this.dialogVisible,
      displayModalWaiver: true,
      waiverDialogType: 'event',
      amaId: null,
      organizerId: null,
      organizationName: "",
      amaD14Id: null,
      amad14Data: {
        "organizationId": 0,
        "userId": 0,
        "url": "",
        "organizationName": "",
      },
      errorMsg: '',
      colorMessage: '#ff0000',
      organizationsAvailableForAma: [],
      membershipPrices:[],
      panelMemberships: 0,
      registrationObjLocal: {
        participants: [],
        extraItems: []
      },
      parentGuardianDialogOpen: false,
      parentGuardianDialogMinor: null,
      parentGuardianByMinor: {},
      blockedMinorIds: [],
      membershipWaiverStatusRefreshKey: '',
      membershipWaiverColumnVisible: false
    }
  },
  computed: {
    modalTitle() {
      if (this.requireAmaDialog) {
        return this.$tc("registerEvent.require_ama");
      } else if (this.requireAmaD14Dialog) {
        return this.$tc("registerEvent.require_ama_d14");
      }
      return '';
    },
    dateEventRequired() {
      return this.registrationObj.eventSel && this.registrationObj.eventSel.eventDate ? formatDateForHumans(this.registrationObj.eventSel.eventDate, false) : '';
    },
    amaComparisonHeaders() {
      return [
        { text: this.$t("membership.field"), value: "field" },
        { text: this.$t("membership.ama_record"), value: "amaRecord" },
        { text: this.$t("membership.livelaps_profile"), value: "livelapsProfile" }
      ];
    },
    ridersHeaders()
    {
      let header = [
        { text: this.$t("registerEvent.selected"), value: 'selected', width: "10%", sortable: false },
        { text: this.$t("riders.first_name"), align: "", value: "fName" },
        { text: this.$t("riders.last_name"), value: "lName" },
        { text: this.$t("riders.status"), value: "status" },
        { text: this.$t("riders.emergency_contact"), value: "emergencyContact", align: "center" }
      ];
      let filterEventWaivers = Array.isArray(this.participantsSel) ? this.participantsSel.filter((el) =>
      {
        return (el.eventWaiver && el.eventWaiver != "");
      }) : [];
      if (filterEventWaivers.length > 0)
      {
        header.push({ text: this.$t("riders.event_waiver"), value: "eventWaiver", align: "center" });
      }
      if (this.isMembership)
      {
        header.push({ text: this.$t("riders.membership"), value: "membership" });
      }
      if (this.shouldShowMembershipWaiverColumn)
      {
        header.push({ text: this.$t("riders.membership_waiver"), value: "waivers" });
      }
      if (this.registrationObj && this.registrationObj.eventSel && this.registrationObj.eventSel.isMultiReg)
      {
        header.push({ text: this.$t("riders.classes"), value: "classes" });
      }
      return header;
    },
    partSel()
    {
      const parts = Array.isArray(this.registrationObj.participants) ? this.registrationObj.participants.filter((el) =>
      {
        return el.selected;
      }) : [];
      return parts;
    },
    stepBack()
    {
      const backStep = this.step - 1;
      return backStep > 0 ? backStep : 1;
    },
    emergencyContactAll()
    {
      if (this.registrationObj)
      {
        const emergencyContactFailed = Array.isArray(this.registrationObj.participants) ? this.registrationObj.participants.filter((el) =>
        {
          return el.emergencyContact == 0;
        }) : [];
        return emergencyContactFailed.length > 0;
      }
      return false;
    },
    membershipAll()
    {
      if (this.registrationObj)
      {
        const membershipFailed = Array.isArray(this.registrationObj.participants) ? this.registrationObj.participants.filter((el) =>
        {
          return el.membership != this.$t('registerEvent.valid_member');
        }) : [];
        return membershipFailed.length > 0;
      }
      return false;
    },
    signedEventWaiverAll()
    {
      if (!!this.registrationObj && !!this.registrationObj.eventSel)
      {
        let waiverFailed = Array.isArray(this.participantsSel) ? this.participantsSel.filter((el) =>
        {
          return el.eventWaiver && el.eventWaiver != "" && el.eventWaiverCode != "Signed";
        }) : [];
        return waiverFailed.length > 0;
      }
      return false;
    },
    shouldShowMembershipWaiverColumn() {
      if (!this.isMembership) {
        return false;
      }
      if (this.membershipWaiverColumnVisible) {
        return true;
      }
      return Array.isArray(this.participantsSel) && this.participantsSel.some((participant) => (
        participant && (
          participant.waiversColor === true ||
          !!participant.waiversLabel ||
          (
            participant.requiresRelatedOrgWaiver === true &&
            Array.isArray(participant.missingForcedOrgWaivers) &&
            participant.missingForcedOrgWaivers.length > 0
          )
        )
      ));
    },
    ...mapState({
      urlDomain: (state) => state.env.get("VUE_APP_ROOT"),
      userStore: (state) => state.session.user,
      sessionParticipants: (state) => state.session.participants || [],
      languages: (state) => state.constants.languages,
      roleActive: (state) => state.waiverDialog.roleActive
    }),
    isAccountManagerForSelectedParticipant() {
      return this.isAccountManagerForParticipant(this.itemSelected);
    },
    bShowDescription()
    {
      if (this.registrationObj.eventSel)
      {
        return (
          (this.registrationObj.eventSel.address || "").length > 0 ||
          (this.registrationObj.eventSel.city || "").length > 0 ||
          (this.registrationObj.eventSel.state || "").length > 0 ||
          (this.registrationObj.eventSel.country || "").length > 0 ||
          (this.registrationObj.eventSel.zip || "").length > 0 ||
          (this.eventDescription || "").length > 0
        );
      }
      return false;
    },
    participantsSel()
    {
      if (this.registrationObj)
      {
        if (!(this.registrationObj.eventSel != null && this.registrationObj.eventSel.isSpectatorRegistration == 0))
        {
          let participants = this.registrationObj.participants.filter((el) =>
          {
            let find = (this.registrationObj.participantsSel || []).find((el1) => el1.userId == el.userId);
            return !!find;
          });
          return participants;
        }
        return this.registrationObj.participants;
      }
      return [];
    },
    isMembershipRequired()
    {
      const eventOrganizations = this.eventOrganizations.map(organization => organization.allowSignup);
      return this.isMembership && this.membershipAll && this.registrationObj.eventSel && eventOrganizations.includes(1);
    },
    disabledForNotOpen()
    {
      if (this.registrationObj && this.registrationObj.eventSel)
      {
        return this.registrationObj.eventSel.type == "soon";
      }
      return false;
    },
    pendingMembershipWaiverCount()
    {
      return Array.isArray(this.partSel)
        ? this.partSel.filter((item) => item && item.waiversColor === true).length
        : 0;
    },
    textForBtnNext()
    {
      if (this.registrationObj && this.registrationObj.eventSel && this.registrationObj.eventSel.type == "soon")
      {
        return this.$t('registerEvent.warning_not_open')
      }
      if (this.pendingMembershipWaiverCount > 0)
      {
        return this.$t('waivers.signWaivers');
      }
      return this.$t('registerEvent.next')
    },
    promoterName()
    {
      if (this.registrationObj && this.registrationObj.promoterSel)
      {
        return this.registrationObj.promoterSel.promoterName;
      }
      return '';
    },
    ageAdult() {
      try {
      if (this.registrationObj?.eventSel?.adultAge) {
          return this.registrationObj.eventSel.adultAge;
        }
        return 18;
      } catch {
        return 18;
      }
    }
  },
  methods: {
    isAccountManagerForParticipant(participant) {
      const id = Number(participant?.userId || 0);
      const currentUserId = Number(this.userStore?.id || this.userStore?.userId || 0);
      if (!id || !currentUserId) return false;
      if (id === currentUserId) return true;
      const managed = Array.isArray(this.sessionParticipants) ? this.sessionParticipants.slice(1) : [];
      const fromSession = managed.some((p) => Number(p?.userId || p?.id) === id);
      const accountManagerUserId = Number(participant?.accountManagerUserId ?? participant?.fkUsersIdMaster ?? 0);
      const fromAccountManagerUserId = accountManagerUserId > 0 && accountManagerUserId === currentUserId;
      const managerAccountRaw = (participant?.managerAccount ?? "").toString().trim();
      const fromManagerAccountYou = managerAccountRaw === "You" || managerAccountRaw.toLowerCase() === "you";
      const managerIds = managerAccountRaw
        .split(',')
        .map((s) => parseInt(String(s).trim(), 10))
        .filter((n) => Number.isInteger(n) && n > 0);
      const fromManagerAccountIds = managerIds.length > 0 && managerIds.includes(currentUserId);
      return fromSession || fromAccountManagerUserId || fromManagerAccountYou || fromManagerAccountIds;
    },
    handleRefreshWaiverStatus() {
      this.emitWaiverRefresh();
    },
    emitWaiverRefresh() {
      if (this.disableWaiverRefresh) return;
      this.$emit('refreshEventWaiverStatus', 'participants');
    },
    createWaiverTrace(dialogType, participant) {
      return {
        traceId: `wf-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`,
        dialogType,
        participantId: participant?.userId,
        participantName: `${participant?.fName || ""} ${participant?.lName || ""}`.trim(),
        eventId: this.registrationObj?.eventSel?.id || null
      };
    },
    getMembershipRowsFromResponse(response) {
      const payload = response?.data;
      if (Array.isArray(payload)) {
        return payload;
      }
      if (payload?.success === 1 && Array.isArray(payload?.message)) {
        return payload.message;
      }
      return [];
    },
    async fetchMembershipWaiverRowsWithFallback(requestData, traceId = "") {
      void traceId;
      try {
        const response = await MembershipWaiverService.getMembershipWaiversList(requestData);
        const ok = Array.isArray(response?.data) || response?.data?.success === 1;
        if (ok) {
          return {
            rows: this.getMembershipRowsFromResponse(response),
            source: "/participant/membership/waivers/list",
            response
          };
        }
      } catch (error) {
        // Fallback to legacy endpoint below.
      }

      // Backward-compatible fallback while backend list endpoint stabilizes.
      const legacyResponse = await MembershipWaiverService.getParticipantsWaivers(requestData);
      const legacyRows = Array.isArray(legacyResponse?.data) ? legacyResponse.data : [];
      return {
        rows: legacyRows,
        source: "/participant/membership/waivers",
        response: legacyResponse
      };
    },
    async prepareMembershipWaiversForUsers(usersId = []) {
      const eventId = Number(this.registrationObj?.eventSel?.id || 0);
      const normalizedUsers = Array.isArray(usersId)
        ? usersId.map((id) => Number(id)).filter((id) => id > 0)
        : [];
      if (!eventId || normalizedUsers.length === 0) {
        return;
      }
      try {
        await RegistrationService.prepareEventForcedWaivers({
          eventId,
          usersId: normalizedUsers
        });
      } catch (error) {
        // Keep flow alive; list fetch handles fallback/retry.
      }
    },
    buildMembershipWaiverTitle(row, participant) {
      const participantFullName = `${participant?.fName || ''} ${participant?.lName || ''}`.trim().toLowerCase();
      const candidates = [
        row.membershipWaiverTitle,
        row.waiverTitle,
        row.waiverName,
        row.title,
        row.waiver && row.waiver.title,
        row.waiver && row.waiver.name,
        row.nameWaiver
      ]
        .map((value) => (value || '').toString().trim())
        .filter((value) => value.length > 0 && value.toLowerCase() !== participantFullName);
      const resolved = candidates[0] || this.$t('riders.membership_waiver');
      return resolved;
    },
    getMembershipWaiverScopeParticipants(participant, explicitScope = null) {
      const source = Array.isArray(explicitScope) && explicitScope.length > 0
        ? explicitScope
        : (Array.isArray(this.partSel) && this.partSel.length > 0 ? this.partSel : [participant]);
      const seen = new Set();
      return source
        .filter((item) => item && Number(item.userId || 0) > 0)
        .filter((item) => {
          const userId = Number(item.userId || 0);
          if (seen.has(userId)) return false;
          seen.add(userId);
          return true;
        });
    },
    normalizeMembershipWaiversForDialog(rows, participants, trace) {
      const participantsList = Array.isArray(participants) ? participants : [participants].filter(Boolean);
      const participantsByUserId = new Map();
      participantsList.forEach((participant) => {
        const userId = Number(participant?.userId || 0);
        if (userId > 0) {
          participantsByUserId.set(userId, participant);
        }
      });
      const fallbackParticipant = participantsList[0] || {};
      const normalizedMap = new Map();
      rows.forEach((row, index) => {
        const userId = Number(row.userId || row.racerUserId || row.participantUserId || row.riderUserId || 0);
        const participant = participantsByUserId.get(userId) || fallbackParticipant;
        if (!participant || !userId) {
          return;
        }
        const birthday = Object.prototype.hasOwnProperty.call(participant, 'birthdayString')
          ? participant.birthdayString
          : participant.birthday;
        const templateId = Number(
          row.membershipWaiverTemplateId ||
          row.fkWaiverId ||
          row.waiverId ||
          row.templateWaiverId ||
          row.id ||
          0
        );
        const title = this.buildMembershipWaiverTitle(row, participant);
        const link = (row.waiverLink || row.link || "").toString().trim();
        const linkBase = link ? link.replace(/\/[0-9a-fA-F-]{36}$/, "") : "";
        const fallbackTemplateRef = templateId > 0
          ? templateId
          : (row.membershipWaiverTitle || row.waiverTitle || row.waiverName || row.title || title || linkBase || `fallback-${index}`);
        const dedupeKey = `${userId}-${fallbackTemplateRef}`;
        const statusRaw = (row.waiverStatus || row.status || '').toString().trim().toLowerCase();
        const isSigned = statusRaw === 'signed' || statusRaw === '2' || statusRaw === '4';
        const isRejected = statusRaw === 'rejected' || statusRaw === '3';
        const waiverstatus = isSigned ? 'Signed' : (isRejected ? 'Rejected' : 'NotSigned');
        const hasMinorFlag = row.isMinor !== undefined && row.isMinor !== null && `${row.isMinor}` !== "";
        const normalizedIsMinor = hasMinorFlag
          ? (Number(row.isMinor) === 1 ? 1 : 0)
          : (birthday
            ? (this.age18Calculate(birthday) ? 0 : 1)
            : (this.itemSelectedIsMinor === true ? 1 : 0));
        const normalized = {
          ...row,
          userId,
          riderUserId: userId,
          racerUserId: userId,
          eventId: Number(row.eventId || row.fkEventId || row.eventsId || this.registrationObj?.eventSel?.id || 0),
          organizationId: row.organizationId || null,
          membershipWaiverTemplateId: templateId || null,
          membershipWaiverTitle: title,
          required: (
            Number(row.required) === 1 ||
            Number(row.qtSignReq) > 0 ||
            Number(row.signaturesRequired) > 0
          ) ? 1 : 0,
          waiverstatus,
          signUserId: row.signUserId || null,
          signatoryName: row.signatoryName || null,
          signatoryLastname: row.signatoryLastname || null,
          signatoryEmail: row.signatoryEmail || null,
          isMinor: normalizedIsMinor,
          riderFirstName: row.riderFirstName || participant.fName || '',
          riderLastName: row.riderLastName || participant.lName || '',
          riderEmail: row.riderEmail || row.email || participant.email || participant.emailAddress || '',
          participantName: row.participantName || participant.fName || '',
          participantLastname: row.participantLastname || participant.lName || '',
          participantEmail: row.participantEmail || participant.email || participant.emailAddress || '',
          participantGender: row.participantGender || participant.gender || '',
          participantDateOfBirth: row.participantDateOfBirth || birthday || null,
          accountManagerUserId: Number(participant.accountManagerUserId ?? participant.fkUsersIdMaster ?? 0) || null,
          fkUsersIdMaster: Number(participant.fkUsersIdMaster ?? participant.accountManagerUserId ?? 0) || null,
          managerAccount: participant.managerAccount || null,
          waiverInstanceId: row.waiverInstanceId || row.id || null,
          // For Sign Now modal flow, prefer concrete generated instance id.
          eventWaiverId: row.waiverInstanceId || row.id || templateId,
          fkWaiverId: templateId || row.fkWaiverId || row.id || row.waiverId,
          waiverTranslate: { first: { title } },
          fullName: `${row.riderFirstName || participant.fName || ''} ${row.riderLastName || participant.lName || ''}`.trim(),
          age18: normalizedIsMinor === 1 ? false : (birthday ? this.age18Calculate(birthday) : true),
          isMembershipWaiver: true,
          sourceColumn: 'membershipWaiver',
          dialogKey: dedupeKey,
          _traceId: trace.traceId
        };
        const previous = normalizedMap.get(dedupeKey);
        if (!previous) {
          normalizedMap.set(dedupeKey, normalized);
          return;
        }
        if (normalized.waiverstatus === 'Signed' && previous.waiverstatus !== 'Signed') {
          normalizedMap.set(dedupeKey, normalized);
          return;
        }
        if (normalized.waiverstatus === previous.waiverstatus) {
          const prevDate = new Date(previous.createdDate || previous.createDate || 0).getTime() || 0;
          const currDate = new Date(normalized.createdDate || normalized.createDate || 0).getTime() || 0;
          if (currDate > prevDate) {
            normalizedMap.set(dedupeKey, normalized);
          }
        }
      });
      return Array.from(normalizedMap.values());
    },
    init() {
      this.getAMAId();
    },
    becomeAMember(organizationId)
    {
      if (this.registrationObj && this.registrationObj.eventSel) {
        try {
          const returnData = {
            eventId: this.registrationObj.eventSel.id,
            eventName: this.registrationObj.eventSel.eventName,
            promoterUserId: this.registrationObj.promoterSel ? this.registrationObj.promoterSel.userID : null,
            promoterName: this.registrationObj.promoterSel ? this.registrationObj.promoterSel.promoterName : null,
          };
          localStorage.setItem('member_reg_return_event', JSON.stringify(returnData));
        } catch (e) { /* localStorage may be unavailable */ }
      }
      this.$router.push({ path: '/memberRegistration/' + organizationId });
    },
    async getOrganizationsAvailableForAma(){
      const response = await OrganizationService.getOrganizationsAvailableForAma();
      let responseData = response.data.message;
      this.organizationsAvailableForAma = responseData;
    },
    getAMAId() {
      AMAService.getAMAId().then((resp) => {
        this.amaId = resp.data.message.id;
        this.organizerId = resp.data.message.organizerId;
      });
    },
    getAMAD14() {
      AMAService.getAMAD14().then((resp) => {
        this.amaD14Id = resp.data.message.id;
        this.getValidationAPI();
      });
    },
    getValidationAPI() {
      AMAService.getValidationAPI().then((resp) => {
        let _resp= resp.data.message;
        if(_resp.length > 0) {
          this.amaD14Data = _resp[0];
        }
      });
      
    },
    closeAmaDialog() {
      this.requireAmaDialog = false;
      this.requireAmaD14Dialog = false;
      this.amaDialog = false;
      this.participantsSel.forEach(participant => {
        participant.amaMembership = '';
        participant.amaStatus = false;
        participant.amaD14Membership = '';
        participant.amaD14Status = false;
        this.$set(participant, 'showAmaInfo', false);
        this.$set(participant, 'amaErrorMsg', '');
        this.$set(participant, 'amaColorMessage', '#ff0000');
        this.$set(participant, 'amaLoading', false);
        this.$set(participant, 'membershipResponseItems', []);
        this.$set(participant, 'amaUpdateData', null);
      });
    },
    resetParticipantAmaInfo(participant) {
      this.$set(participant, 'showAmaInfo', false);
      this.$set(participant, 'amaErrorMsg', '');
      this.$set(participant, 'amaColorMessage', '#ff0000');
      this.$set(participant, 'membershipResponseItems', []);
      this.$set(participant, 'amaUpdateData', null);
    },
    isParticipantOwner(participant) {
      const id = Number(participant?.userId || 0);
      const currentUserId = Number(this.userStore?.id || this.userStore?.userId || 0);
      return id && id === currentUserId;
    },
    isParticipantAccountManager(participant) {
      const id = Number(participant?.userId || 0);
      const currentUserId = Number(this.userStore?.id || this.userStore?.userId || 0);
      if (!id) return false;
      const managed = Array.isArray(this.sessionParticipants) ? this.sessionParticipants.slice(1) : [];
      return id === currentUserId || managed.some((p) => Number(p?.userId || p?.id) === id);
    },
    goToProfileAMA() {
      window.open("https://ama.users.membersuite.com/auth/portal-login", '_blank');
    },
    async updateAmaProfile(participant) {
      const updateData = participant.amaUpdateData;
      if (!updateData) return;
      this.$set(participant, 'amaLoading', true);
      try {
        const profileData = {
          userId: participant.userId,
          authUserId: this.userStore.id
        };
        if (updateData.firstName) profileData.firstName = updateData.firstName;
        if (updateData.lastName) profileData.lastName = updateData.lastName;
        if (updateData.birthDate) profileData.birthDate = updateData.birthDate;

        const response = await ProfileService.updateProfile(profileData);
        if (response && response.data.success) {
          const userResponse = response.data.message;
          this.$set(participant, 'fName', userResponse.firstName || participant.fName);
          this.$set(participant, 'lName', userResponse.lastName || participant.lName);

          this.$set(participant, 'showAmaInfo', false);
          this.$set(participant, 'amaErrorMsg', '');
          this.$set(participant, 'membershipResponseItems', []);
          this.$set(participant, 'amaUpdateData', null);
          this.$store.dispatch('setUserAction');

          const orgType = participant.amaD14Membership ? 'd14' : 'ama';
          await this.validateAMA(participant, orgType);
        } else {
          this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.error_occurred'));
        }
      } catch (error) {
        this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.error_occurred'));
      } finally {
        this.$set(participant, 'amaLoading', false);
      }
    },
    buildAmaComparisonItems(amaProfile, participant) {
      return [
        {
          field: this.$t("membership.first_name"),
          amaRecord: amaProfile.firstName || '',
          livelapsProfile: participant.fName || ''
        },
        {
          field: this.$t("membership.last_name"),
          amaRecord: amaProfile.lastName || '',
          livelapsProfile: participant.lName || ''
        },
        {
          field: this.$t("membership.birth_date"),
          amaRecord: amaProfile.birthDate ? formatDateForHumans(amaProfile.birthDate, false) : '',
          livelapsProfile: participant.birthdayString ? formatDateForHumans(participant.birthdayString, false) : ''
        }
      ];
    },
    showAmaDiscrepancyDialog(errors, amaProfile, participant) {
      const nameErr = errors.find(e => e.error.includes("ama_name_error_message"));
      const birthErr = errors.find(e => e.error.includes("ama_birthdate_error_message"));

      if (!nameErr && !birthErr) {
        const eventDate = this.registrationObj.eventSel && this.registrationObj.eventSel.eventDate
          ? formatDateForHumans(this.registrationObj.eventSel.eventDate, false)
          : '';
        const errorMsg = errors.map(err => {
          const expirationDate = err.name ? formatDateForHumans(err.name, false) : '';
          return this.$t(`membership.${err.error}`, { name: err.name || '', expirationDate, eventDate });
        }).join("<br />");
        this.$set(participant, 'amaErrorMsg', errorMsg);
        return;
      }

      const updateData = {};
      if (nameErr) {
        const [firstName, lastName] = nameErr.name.split(';');
        updateData.firstName = firstName;
        updateData.lastName = lastName;
      }
      if (birthErr) {
        updateData.birthDate = birthErr.name;
      }
      this.$set(participant, 'amaUpdateData', updateData);
      this.$set(participant, 'membershipResponseItems', this.buildAmaComparisonItems(amaProfile, participant));
      this.$set(participant, 'showAmaInfo', true);
      this.$set(participant, 'amaErrorMsg', '');
    },
    _dbLog(message, channel = 'quietD14_registration') {
      const apiBase = this.$store.getters.env.get('VUE_APP_API_LINK');
      if (!apiBase) return;
      fetch(apiBase + '/participant/debug/log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ channel, message: String(message).substring(0, 500) })
      }).catch(() => {});
    },
    /**
     * Quietly adds a D14 membership to a user's profile using their AMA number.
     * This is a fire-and-forget background process that syncs D14 data automatically
     * without blocking the user's registration flow.
     * 
     * @param {Object} participant - The participant object
     * @param {String} amaNumber - The AMA number to use for the quiet D14 API call
     */
    async quietlyAddD14Membership(participant, amaNumber) {
      try {
        this._dbLog('START userId=' + participant.userId + ' amaNumber=' + amaNumber);
        if (!this.amaD14Data || !this.amaD14Data.organizationId) {
          this._dbLog('EXIT: no amaD14Data');
          return;
        }

        const resp = await AMAService.getAMAD14byUserId(participant.userId, this.amaD14Data.organizationId);
        if (resp?.data?.message?.length > 0) {
          this._dbLog('EXIT: D14 already exists');
          return;
        }

        const _eventSelected = this.registrationObj.eventSel;
        const d14Data = {
          d14Number: amaNumber,
          userId: participant.userId,
          date: _eventSelected.eventDate,
          eventEndDate: _eventSelected.eventEndDate,
          organizationMemberTypeId: this.amaD14Data.organizationMemberTypeId,
          organizationId: this.amaD14Data.organizationId || 28,
          isQuiet: true
        };
        this._dbLog('validating D14 with data: ' + JSON.stringify(d14Data));

        const response = await AMAService.validateAMAD14(d14Data);
        const validateResp = response?.data?.message;
        this._dbLog('validateResp: ' + JSON.stringify(validateResp));

        if (validateResp && validateResp.isFound && (!validateResp.errors || validateResp.errors.length === 0)) {
          const _data = {
            organizerId: this.amaD14Data.organizationId || 28,
            organizationName: this.amaD14Data.organizationName,
            allowEmails: 1,
            lifemembercheckbox: (validateResp.expiration && String(validateResp.expiration).toLowerCase().includes('life')) ? 1 : 0,
            expDate: validateResp.expiration || '',
            memberId: String(validateResp.d14Number || amaNumber),
            userId: participant.userId,
            isD14: true,
            isAma: true
          };
          this._dbLog('creating D14 membership: ' + JSON.stringify(_data));
          const createResp = await MembershipService.create(_data);
          this._dbLog('D14 membership create response: ' + JSON.stringify(createResp?.data));
        } else {
          this._dbLog('EXIT: validation failed or not found');
        }
      } catch (error) {
        this._dbLog('ERROR: ' + (error?.message || error));
      }
    },
    async validateAMA(participant, organizationType) {
      const membershipNumber = organizationType === "d14" ? participant.amaD14Membership : participant.amaMembership;
      if (!membershipNumber || !membershipNumber.toString().trim()) {
        this.$set(participant, 'amaErrorMsg', this.$t('membership.membership_number_required'));
        return;
      }

      const orgName = organizationType === "d14" ? (this.amaD14Data.organizationName || 'AMA-D14') : 'AMA';
      this.$set(participant, 'amaLoading', true);
      this.$set(participant, 'amaErrorMsg', '');
      try {
        const _eventSelected = this.registrationObj.eventSel;

        let data = {
          amaNumber: participant.amaMembership,
          userId: participant.userId,
          date: _eventSelected.eventDate,
          eventEndDate: _eventSelected.eventEndDate,
          organizationId: organizationType === "ama" ? (this.amaId || 25) : (this.amaD14Data.organizationId || 28)
        };

        if (organizationType === "d14") {
          data.d14Number = participant.amaD14Membership;
          data.organizationMemberTypeId = this.amaD14Data.organizationMemberTypeId;
          data.organizationId = this.amaD14Data.organizationId;

          const response = await AMAService.validateAMAD14(data);
          const resp = response?.data?.message;

          if (!resp || !resp.isFound) {
            this.$set(participant, 'amaErrorMsg', this.$t('membership.ama_error_message', { organizationName: orgName }));
            return;
          }

          if (resp.errors && resp.errors.length > 0) {
            if (resp.amaProfile) {
              this.showAmaDiscrepancyDialog(resp.errors, resp.amaProfile, participant);
            } else {
              this.$set(participant, 'amaErrorMsg', resp.errors
                .map(err => this.$t(`membership.${err.error}`, { name: err.name }))
                .join("<br />"));
            }
            return;
          }
          
          const _data = {
            organizerId: this.amaD14Data.organizationId || 28,
            organizationName: this.amaD14Data.organizationName,
            allowEmails: 1,
            lifemembercheckbox: 0,
            expDate: resp.expiration || '',
            memberId: participant.amaD14Membership,
            userId: participant.userId,
            isD14: true,
            isAma: true
          };

          const createResp = await MembershipService.create(_data);
          if (createResp.data.success) {
            this.$set(participant, 'amaColorMessage', '#45615f');
            this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.ama_d14_added_to_participant'));
            participant.amaD14Status = true;
          } else {
            this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.error_occurred'));
          }

          return;
        } else {
          const response = await AMAService.validateAMA(data);
          const resp = response.data.message;

          if (!resp || !resp.isFound) {
            this.$set(participant, 'amaErrorMsg', this.$t('membership.ama_error_message', { organizationName: orgName }));
            return;
          }

          if (resp.errors && resp.errors.length > 0) {
            if (_eventSelected.requireAma === "Optional") {
              await MembershipService.delete(participant.userId, this.organizerId);
              participant.amaStatus = true;
              this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.ama_invalida_deleted'));
              return;
            }

            if (resp.amaProfile) {
              this.showAmaDiscrepancyDialog(resp.errors, resp.amaProfile, participant);
            } else {
              this.$set(participant, 'amaErrorMsg', resp.errors
                .map(err => {
                  let name = "";
                  if (err.error.includes("ama_name_error_message")) {
                    const [first, last] = err.name.split(';');
                    name = `${first} ${last}`;
                  } else {
                    name = err.name;
                  }
                  return this.$t(`membership.${err.error}`, { name });
                })
                .join("<br />"));
            }

            return;
          }

          const _data = {
            organizerId: this.amaId || 25,
            organizationName: "AMA",
            allowEmails: 1,
            lifemembercheckbox: (resp.expiration && String(resp.expiration).toLowerCase().includes('life')) ? 1 : 0,
            expDate: resp.expiration,
            memberId: participant.amaMembership,
            userId: participant.userId
          };

          const createResp = await MembershipService.create(_data);

          if (createResp.data.success) {
            this.$set(participant, 'amaColorMessage', '#45615f');
            this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.ama_added_to_participant'));
            participant.amaStatus = true;
            this.quietlyAddD14Membership(participant, participant.amaMembership);
          } else {
            this.$set(participant, 'amaErrorMsg', this.$t('registerEvent.error_occurred'));
          }
        }

      } catch (error) {
        this.$set(participant, 'amaErrorMsg', this.$t('membership.ama_error_message', { organizationName: orgName }));
      } finally {
        this.$set(participant, 'amaLoading', false);
      }
    },
    setAccountStatusDialog(item)
    {
      this.item = item;
      this.accountStatusDialog = true;
    },
    closeAccountStatusDialog()
    {
      this.accountStatusDialog = false;
      this.item = null;
    },
    async getEventDescription()
    {
      this.$emit('getEventDescription');
    },
    setShowMembershipDialog()
    {
      if(this.isMembershipRequired) {
        this.membershipRequiredDialog = true;
      } else {
        const organizationNames = this.eventOrganizations.map(organization => organization.name).join(', ');
        this.eventOrganizations.length > 1 ? 
        this.$emit('alertNotValidate', this.$t('registerEvent.organizations_allow_signup_error', { orgNames: organizationNames })) : 
        this.$emit('alertNotValidate', this.$t('registerEvent.organization_allow_signup_error', { orgName: this.eventOrganizations[0].name }));
      }
    },
    async getOrganizations() {
      if(!this.registrationObj.eventSel) {
        return;
      }
      const eventId = this.registrationObj.eventSel.id;

      try {
        const resp = await APIService.fetch({
        method: "get",
        path: `${this.urlDomain}/laravel/public/api/v1/participant/register/event/membershipRequired/${eventId}`,
        });

        if (resp.data.success) {
          const organizations = resp.data.message;

          const pricePromises = organizations.map(async (org) => {
            const prices = await this.getMembershipPrices(org.organizationId);
            return { ...org, membershipPrices: prices };
          });

          this.eventOrganizations = await Promise.all(pricePromises);
        }
      } catch (error) { 
        this.errorMsg = this.$t('registerEvent.error_occurred');
      }
    },

    async getMembershipPrices(organizationId) {
      const resp = await APIService.fetch({
        method: "get",
        path: `${this.urlDomain}/laravel/public/api/v1/participant/register/event/getMembershipsByOrganizationId/${organizationId}`,
      });

      if (resp.data.success) {
        return resp.data.message;
      }
      return [];
    },
    confirm(val, userId = null)
    {
      let vm = this
      let _selected = (Array.isArray(this.participantsSel) ? this.participantsSel.filter(x => x.selected) : []);
      this.alertQuestion = false
      userId = userId ? userId : _selected[0].userId;
      EventWaiverService.generateWaiverForEventWaiverSignedType(this.registrationObj.eventSel.id, val, userId).then((resp) =>
      {
        if (resp.data.message)
        {
          let waiverE = (resp.data.message.waiverStatus == 'NotSigned' || resp.data.message.waiverStatus == 'Rejected') ? resp.data.message : false;
          if (waiverE)
          {
            vm.waiverEArray.push(waiverE);
          } else
          {
            const signed = resp.data.message.waiverStatus == 'Signed' ? true : false;
            if (!signed)
            {
              this.generateWaiver(val, userId);
            } else
            {
              this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_not_found'));
            }
          }
        } else
        {
          this.generateWaiver(val, userId);
        }
      });

    },
    nextSignItem()
    {
      this.waiverModal = false;
      const prevLength = Array.isArray(this.waiverEArray) ? this.waiverEArray.length : 0;
      this.waiverEArray = Array.isArray(this.waiverEArray) ? this.waiverEArray.filter((item) => { return item.id != this.waiverE.id; }) : [];
      if (this.waiverEArray.length === prevLength && this.waiverEArray.length > 0)
      {
        this.waiverEArray.shift();
      }
      if (this.waiverEArray.length == 0)
      {
        this.resetWaiver = false;
        this.$store.commit('setOverlay', false);
        this.emitWaiverRefresh();
        if (this.waiverRequiredDialog)
        {
          this.getEventWaivers(this.itemSelected);
        }
      }
    },
    nextMembershipSignItem()
    {
      this.membershipWaiverModal = false;
      this.membershipWaiverEArray = Array.isArray(this.membershipWaiverEArray)
        ? this.membershipWaiverEArray.filter((item) => item.id != this.membershipWaiverE.id)
        : [];
      if (this.membershipWaiverEArray.length == 0)
      {
        this.resetMembershipWaiver = false;
        this.$store.commit('setOverlay', false);
        this.refreshSelectedMembershipWaiverStatus();
        if (this.waiverRequiredDialog)
        {
          this.getMembershipWaivers(this.itemSelected);
        }
      }
    },
    async nextSignOrgItem()
    {
      this.waiverOrgModal = false;
      await this.refreshSelectedMembershipWaiverStatus();
      this.$emit('refreshEventWaiverStatus', 'participants');
    },
    async refreshSelectedMembershipWaiverStatus(scopeParticipants = null)
    {
      const item = this.registrationObj.eventSel;
      const selectedScope = Array.isArray(scopeParticipants) && scopeParticipants.length > 0
        ? scopeParticipants
        : (Array.isArray(this.partSel) && this.partSel.length > 0 ? this.partSel : this.participantsSel);
      const selectedRaw = Array.isArray(selectedScope) ? selectedScope : [];
      const selectedByUser = new Map();
      selectedRaw.forEach((participant) => {
        const userId = Number(participant?.userId || 0);
        if (userId > 0) {
          selectedByUser.set(userId, participant);
        }
      });
      const modalUserId = Number(this.itemSelected?.userId || 0);
      if (modalUserId > 0 && !selectedByUser.has(modalUserId)) {
        selectedByUser.set(modalUserId, this.itemSelected);
      }
      const selected = Array.from(selectedByUser.values());
      if (!item || selected.length === 0) {
        return;
      }

      try {
        const usersId = [...new Set(selected.map((p) => Number(p.userId)).filter(Boolean))];
        if (usersId.length === 0) {
          return;
        }

        const data = {
          usersId: selected.map((p) => p.userId),
          eventId: item.id
        };
        const resp = await RegistrationService.checkEventMembership(data);
        const message = resp?.data?.message;
        if (resp?.data?.success !== 1 || !Array.isArray(message)) {
          return;
        }

        const byUserId = new Map(message.map((row) => [Number(row.userId), row]));
        const markWaiverSigned = (participant) => {
          this.$set(participant, 'requiresRelatedOrgWaiver', false);
          this.$set(participant, 'missingForcedOrgWaivers', []);
          this.$set(participant, 'waiversColor', false);
          this.$set(participant, 'waiverSigned', true);
          this.$set(participant, 'waiversLabel', '');
          this.$set(participant, 'waivers', '');
          this.$set(participant, 'waiversKey', '');
          this.$set(participant, 'waiversParams', {});
        };
        const markWaiverPending = (participant, row) => {
          this.$set(participant, 'requiresRelatedOrgWaiver', !!(row && row.requiresRelatedOrgWaiver));
          this.$set(participant, 'missingForcedOrgWaivers', (row && row.missingForcedOrgWaivers) || []);
          this.$set(participant, 'waiversColor', true);
          this.$set(participant, 'waiverSigned', false);
          this.$set(participant, 'waiversLabel', '');
          this.$set(participant, 'waiversKey', 'registerEvent.waiver_signature_required');
          this.$set(participant, 'waiversParams', {});
          this.$set(participant, 'waivers', this.getWaiverLabel(participant));
        };
        const applyWaiverState = (participant) => {
          const row = byUserId.get(Number(participant.userId));
          if (!row) {
            return;
          }
          if (row.result === 'waivers') {
            markWaiverPending(participant, row);
            return;
          }
          if (row.result === 'noclass' && row.hasWaiversToSign) {
            markWaiverPending(participant, row);
            return;
          }
          markWaiverSigned(participant);
        };

        selected.forEach((participant) => applyWaiverState(participant));
        if (Array.isArray(this.registrationObj.participants)) {
          this.registrationObj.participants.forEach((participant) => {
            if (byUserId.has(Number(participant.userId))) {
              applyWaiverState(participant);
            }
          });
        }

        // Normalize blocking state using the new stable membership waiver list endpoint.
        const defaultOrganizationId = Number(
          this.registrationObj?.eventSel?.organizationId ||
          this.registrationObj?.eventSel?.fkOrganizationId ||
          this.registrationObj?.eventSel?.organizationID ||
          0
        );
        const listPayload = {
          usersId: selected.map((p) => p.userId),
          eventId: item.id
        };
        if (defaultOrganizationId > 0) {
          listPayload.defaultOrganizationId = defaultOrganizationId;
        }
        const listFetch = await this.fetchMembershipWaiverRowsWithFallback(listPayload);
        const listRows = listFetch.rows;
        const hasMembershipWaiverRows = listRows.some((row) => (
          Number(row.required) === 1 ||
          Number(row.qtSignReq) > 0 ||
          Number(row.signaturesRequired) > 0
        ));
        this.membershipWaiverColumnVisible = hasMembershipWaiverRows;
        const pendingByUser = new Map();
        const usersWithListRows = new Set();
        listRows.forEach((row) => {
          const userId = Number(row.userId);
          usersWithListRows.add(userId);
          const signaturesRequired = Number(row.signaturesRequired || row.qtSignReq || row.required || 0);
          const signaturesSigned = Number(row.signaturesSigned || 0);
          const allSignaturesComplete = row.allSignaturesComplete;
          const hasRequirement = signaturesRequired > 0 || Number(row.required) === 1;
          const statusRaw = (row.waiverStatus || row.status || '').toString().trim().toLowerCase();
          const isSigned = statusRaw === 'signed' || statusRaw === '2' || statusRaw === '4';
          const isComplete = typeof allSignaturesComplete === 'boolean'
            ? allSignaturesComplete
            : (signaturesRequired > 1 ? signaturesSigned >= signaturesRequired : isSigned);
          if (!hasRequirement || isComplete) {
            return;
          }
          pendingByUser.set(userId, {
            signaturesRequired,
            signaturesSigned
          });
        });
        const applyPendingStatus = (participant) => {
          if (!participant) return;
          const userId = Number(participant.userId);
          const hasRows = usersWithListRows.has(userId);
          const pendingWaiver = pendingByUser.get(Number(participant.userId));
          const hasPending = !!pendingWaiver;
          const hasForcedRelatedPending = participant.requiresRelatedOrgWaiver === true &&
            Array.isArray(participant.missingForcedOrgWaivers) &&
            participant.missingForcedOrgWaivers.length > 0;
          if (hasPending) {
            const waiverLabel = pendingWaiver.signaturesRequired > 1
              ? `${pendingWaiver.signaturesSigned}/${pendingWaiver.signaturesRequired} ${this.$t('common.Signed')}`
              : '';
            this.$set(participant, 'waiversColor', true);
            this.$set(participant, 'waiverSigned', false);
            this.$set(participant, 'waiversLabel', waiverLabel);
            this.$set(participant, 'waiversKey', waiverLabel ? '' : 'registerEvent.waiver_signature_required');
            this.$set(participant, 'waiversParams', {});
            this.$set(participant, 'waivers', this.getWaiverLabel(participant));
            return;
          }
          if (!hasRows && hasForcedRelatedPending) {
            this.$set(participant, 'waiversColor', true);
            this.$set(participant, 'waiverSigned', false);
            this.$set(participant, 'waiversLabel', '');
            this.$set(participant, 'waiversKey', 'registerEvent.waiver_signature_required');
            this.$set(participant, 'waiversParams', {});
            this.$set(participant, 'waivers', this.getWaiverLabel(participant));
            return;
          }
          if (hasRows) {
            markWaiverSigned(participant);
          }
        };
        selected.forEach((participant) => applyPendingStatus(participant));
        if (Array.isArray(this.registrationObj.participants)) {
          this.registrationObj.participants.forEach((participant) => {
            if (byUserId.has(Number(participant.userId))) {
              applyPendingStatus(participant);
            }
          });
        }
      } catch (error) {
        // Keep current participant flags if refresh fails.
      }
    },
    async handleRefreshMembershipWaiverStatus() {
      await this.refreshSelectedMembershipWaiverStatus();
      if (this.waiverDialogType === 'membership' && this.waiverRequiredDialog && this.itemSelected) {
        await this.getMembershipWaivers(this.itemSelected);
      }
    },
    queueInitialMembershipWaiverStatusRefresh(selectedParticipants) {
      if (!this.isMembership || !this.registrationObj || !this.registrationObj.eventSel) {
        return;
      }
      const participants = Array.isArray(selectedParticipants) ? selectedParticipants : [];
      const usersId = participants.map((participant) => Number(participant && participant.userId)).filter(Boolean);
      if (usersId.length === 0) {
        return;
      }
      const eventId = Number(this.registrationObj.eventSel.id || 0);
      if (!eventId) {
        return;
      }
      const refreshKey = `${eventId}:${usersId.slice().sort((a, b) => a - b).join(',')}`;
      if (this.membershipWaiverStatusRefreshKey === refreshKey) {
        return;
      }
      this.membershipWaiverStatusRefreshKey = refreshKey;
      this.$nextTick(async () => {
        try {
          await this.refreshSelectedMembershipWaiverStatus(participants);
        } catch (error) {
          // Keep initial table render alive; explicit validation still refreshes.
        }
      });
    },
    getWaiverLabel(participant) {
      if (participant && participant.waiversLabel) {
        return participant.waiversLabel;
      }
      if (participant && participant.waiversKey) {
        return this.$t(participant.waiversKey, participant.waiversParams || {});
      }
      if (!participant || !participant.waiversColor) {
        return "";
      }
      return this.$t("registerEvent.waiver_signature_required");
    },
    isSameParticipantWaiver(waiver, participant) {
      if (!waiver || !participant) {
        return false;
      }
      const participantUserId = Number(participant.userId);
      const possibleUserIdKeys = ['userId', 'participantUserId', 'participantId', 'fkUserId', 'fkParticipantId'];
      const hasIdMatch = possibleUserIdKeys.some((key) => Number(waiver[key]) === participantUserId);
      if (hasIdMatch) {
        return true;
      }
      const waiverName = `${String(waiver.participantName || '').trim()} ${String(waiver.participantLastname || '').trim()}`.trim().toLowerCase();
      const participantName = `${String(participant.fName || '').trim()} ${String(participant.lName || '').trim()}`.trim().toLowerCase();
      return waiverName !== '' && waiverName === participantName;
    },
    async openOrganizationWaivers(participant = null)
    {
      try {
        const response = await WaiverService.getOrganizationsWaiwers();
        if (response?.data?.success === 1) {
          const waivers = Array.isArray(response.data.message) ? response.data.message : [];
          let waiversForModal = waivers;
          if (participant) {
            const filteredWaivers = waivers.filter((waiver) => this.isSameParticipantWaiver(waiver, participant));
            // Fallback to full list if backend payload has no participant identifiers.
            waiversForModal = filteredWaivers.length > 0 ? filteredWaivers : waivers;
          }
          if (waiversForModal.length > 0) {
            this.waiverOrg = waiversForModal;
            this.waiverOrgModal = true;
            return true;
          }
        }
      } catch (error) {
        // fallback below
      }
      return false;
    },
    generateWaiver(val, userId = null)
    {
      let vm = this
      let _selected = (Array.isArray(this.participantsSel) ? this.participantsSel.filter(x => x.selected) : []);
      userId = userId ? userId : _selected[0].userId;
      let data = {
        eventsId: [
          {
            id: this.registrationObj.eventSel.id,
            usersId: [{ id: userId, roles: [val] }]
          }
        ]
      };
      return EventWaiverService.generateWaiverForSpectator(data).then((response) =>
      {
        if (response.data.success && response.data.message.length > 0)
        {
          let waiversE = response.data.message;
          waiversE.forEach((waiverItem) =>
          {
            let waiversItem = waiverItem.waivers;
            waiversItem.forEach((waiverE) =>
            {
              if (waiverE && waiverE.waiverStatus != 'Signed')
              {
                vm.waiverEArray.push(waiverE)
              } else if (!waiverE)
              {
                this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_no_generate'));
              }
            });
          });
          if (vm.waiverEArray.length === 0)
          {
            vm.$store.commit('setOverlay', false);
            vm.emitWaiverRefresh();
          }
        } else
        {
          this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_no_generate'));
        }
      })
    },
    nextStep(step)
    {
      this.$emit('nextStep', step);
    },
    setLoading(status)
    {
      this.loading = status;
    },
    async validateAmaGeneric(selectedParticipants, organizationName, item = null, organizationType = 'AMA') {
      const isD14 = organizationType === 'D14';

      const dialogStatuses = await Promise.all(
        selectedParticipants.map(async (participant) => {
          let shouldShowDialog = false;
          let participantErrorMsg = '';
          const resp = isD14
            ? await AMAService.getAMAD14byUserId(participant.userId, this.amaD14Data.organizationId || 28)
            : await AMAService.getAMAbyUserId(participant.userId, this.amaId || 25);

          const amaRecords = resp?.data?.message ?? [];

          if (amaRecords.length > 0) {
            let payload = {};

            if (isD14) {
              participant.amaD14Membership = amaRecords[0].memberId;

              const amaOrg = this.organizationsAvailableForAma.find(o => o.organizationId === 28);
              if (amaOrg) {
                participant.organizationMemberTypeId = amaOrg.organizationMemberTypeId;
              }

              payload = {
                d14Number: amaRecords[0].memberId,
                organizationMemberTypeId: participant.organizationMemberTypeId,
                userId: participant.userId,
                organizationId: 28,
              };
            } else {
              participant.amaMembership = amaRecords[0].memberId;
              payload = {
                amaNumber: amaRecords[0].memberId,
                userId: participant.userId,
                date: item?.eventDate,
                eventEndDate: item?.eventEndDate,
                organizationId: this.amaId || 25,
              };
            }

            let responseValidate = isD14
              ? await OrganizationService.validateD14AMA(payload)
              : await AMAService.validateAMA(payload);

            responseValidate = responseValidate?.data?.message || {};

            if (!responseValidate.isFound) {
              participantErrorMsg = this.$t("membership.ama_error_message", { organizationName });
              shouldShowDialog = true;
              participant[isD14 ? 'amaD14Status' : 'amaStatus'] = false;
            } else if (responseValidate.errors && responseValidate.errors.length > 0) {
              if (responseValidate.amaProfile) {
                this.showAmaDiscrepancyDialog(responseValidate.errors, responseValidate.amaProfile, participant);
              } else {
                participantErrorMsg = responseValidate.errors
                  .map(err => {
                    let name = "";
                    if (err.error.includes("ama_name_error_message")) {
                      name = err.name.split(';')[0] + " " + err.name.split(';')[1];
                    } else {
                      name = err.name;
                    }
                    return this.$t(`membership.${err.error}`, { name });
                  })
                  .join("<br />");
              }
              shouldShowDialog = true;
              participant[isD14 ? 'amaD14Status' : 'amaStatus'] = false;
            } else {
              participant[isD14 ? 'amaD14Status' : 'amaStatus'] = true;
              
              const _data = {
                organizerId: isD14 ? (this.amaD14Data.organizationId || 28) : (this.amaId || 25),
                organizationName: isD14 ? this.amaD14Data.organizationName : 'AMA',
                allowEmails: 1,
                lifemembercheckbox: (responseValidate.expiration && String(responseValidate.expiration).toLowerCase().includes('life')) ? 1 : 0,
                expDate: responseValidate.expiration || '',
                memberId: isD14 ? (responseValidate.d14Number || amaRecords[0].memberId) : amaRecords[0].memberId,
                userId: participant.userId,
                isD14: isD14,
                isAma: !isD14
              };
              MembershipService.create(_data).catch(() => {});

              if (!isD14) {
                this.quietlyAddD14Membership(participant, amaRecords[0].memberId);
              }
            }
          } else {
            let fallbackSuccess = false;
            // D14 Pre-Dialog Quiet Sync Logic:
            // If the user does not have a D14 membership on file, but they DO have an AMA membership,
            // we attempt a quiet D14 API call using their AMA number BEFORE showing the D14 dialog.
            // If this quiet call succeeds, we create the D14 membership, set status to true, and skip the dialog.
            if (isD14) {
              // Try to find AMA membership to use for quiet D14 call
              const amaResp = await AMAService.getAMAbyUserId(participant.userId, this.amaId || 25);
              const amaExistingRecords = amaResp?.data?.message ?? [];
              if (amaExistingRecords.length > 0) {
                const amaNumber = amaExistingRecords[0].memberId;
                this._dbLog('D14 is missing, but user has AMA. Trying quiet D14 call with AMA number: ' + amaNumber);
                const d14Data = {
                  d14Number: amaNumber,
                  userId: participant.userId,
                  date: item?.eventDate,
                  eventEndDate: item?.eventEndDate,
                  organizationMemberTypeId: this.amaD14Data.organizationMemberTypeId,
                  organizationId: this.amaD14Data.organizationId || 28,
                  isQuiet: true
                };
                const fallbackResponse = await AMAService.validateAMAD14(d14Data);
                const fallbackResp = fallbackResponse?.data?.message;

                if (fallbackResp && fallbackResp.isFound && (!fallbackResp.errors || fallbackResp.errors.length === 0)) {
                  this._dbLog('Quiet D14 call successful, creating D14 membership');
                  const _data = {
                    organizerId: this.amaD14Data.organizationId || 28,
                    organizationName: this.amaD14Data.organizationName,
                    allowEmails: 1,
                    lifemembercheckbox: (fallbackResp.expiration && String(fallbackResp.expiration).toLowerCase().includes('life')) ? 1 : 0,
                    expDate: fallbackResp.expiration || '',
                    memberId: fallbackResp.d14Number || amaNumber,
                    userId: participant.userId,
                    isD14: true,
                    isAma: false
                  };
                  await MembershipService.create(_data);
                  participant.amaD14Membership = fallbackResp.d14Number || amaNumber;
                  participant.amaD14Status = true;
                  fallbackSuccess = true;
                } else {
                  this._dbLog('Quiet D14 call failed or not found');
                }
              }
            }

            if (!fallbackSuccess) {
              shouldShowDialog = true;
              participant[isD14 ? 'amaD14Status' : 'amaStatus'] = false;
            }
          }
          this.$set(participant, 'amaErrorMsg', participantErrorMsg);
          return shouldShowDialog;
        })
      );
      return dialogStatuses.some(status => status === true);
    },
    /**
     * Validates the riders' registration process, checks registration status,
     * and handles different registration timeframes.
     *
     * This function handles the validation of a rider's registration status, checks
     * the current time against registration open/close times, and emits appropriate
     * events based on the validation outcome.
     */
    async validateRiders() {
      this.init();
      this.waiverRequiredDialog = false;
      this.loading = true;
      // Check if any participants are selected
      if (this.partSel.length === 0) {
        this.loading = false;
        this.$emit('alertNotValidate', this.$t('registerEvent.error_selected_one'));
        this.loading = false;
        return;
      }

      // Check membership requirements
      this.membershipRequiredDialog = false;
      const _requiredMember = this.partSel.filter(item => item.membershipColor === true);
        if(_requiredMember.length > 0 && this.isMembership){
          this.getOrganizations();
          this.membershipRequiredDialog = true;
        this.loading = false;
        return;
      }
      // Re-sync waiver state first so stale UI flags do not block Next after signing.
     await this.refreshSelectedMembershipWaiverStatus();
      // Check required (membership/forced-org) waivers: create records, block for other-adult, or prompt to sign
      const _missingWaivers = this.partSel.filter(item => item.waiversColor === true);
      if (_missingWaivers.length > 0) {
        // Issue #116: handle minor waivers via ParentGuardianDialog +
        // direct MembershipWaiverService generation. Returns 'completed'
        // (signing UI queued or actionable error already shown) and
        // 'blocked' (Other selected) → both short-circuit the legacy
        // empty MembershipWaiverDialog. 'no-minors' falls through to
        // the existing adult-only flow.
        const minorOutcome = await this.handleMinorMembershipWaivers(_missingWaivers);
        if (minorOutcome === 'completed' || minorOutcome === 'blocked') {
          this.loading = false;
          return;
        }
        const firstMissing = _missingWaivers[0];
        let blockerMessage = this.$t('registerEvent.waiver_signature_required_before_continue');
        try {
          const item = this.registrationObj.eventSel;
          const prepareResp = await RegistrationService.prepareEventForcedWaivers({
            eventId: item.id,
            usersId: _missingWaivers.map(p => p.userId)
          });
          const msg = prepareResp.data?.message;
          if (prepareResp.data?.success === 1 && msg) {
            if (msg.otherAdults && msg.otherAdults.length > 0) {
              const names = msg.otherAdults.map(a => `${a.firstName} ${a.lastName}`).join(', ');
              blockerMessage = this.$t('registerEvent.other_adult_must_sign_waiver', { names });
            }
            if (msg.invalidEmailAdults && msg.invalidEmailAdults.length > 0) {
              const names = msg.invalidEmailAdults.map(a => `${a.firstName} ${a.lastName}`).join(', ');
              blockerMessage = this.$t('registerEvent.invalid_email_adult_waiver', { names });
            }
          }
        } catch (err) {
          // if API fails, fall back to simple message
        }
        this.$emit('alertNotValidate', blockerMessage);
        await this.getMembershipWaivers(firstMissing, _missingWaivers);
        this.loading = false;
        return;
      }
      // Check AMA-D14
      // If D14 is mandatory, we run the generic validation flow.
      // NOTE: Inside validateAmaGeneric, if the user lacks D14 but has AMA,
      // it will quietly attempt to fetch D14 using their AMA number before showing the dialog.
      const participants = this.registrationObj.participants;
      const item = this.registrationObj.eventSel;
      if (item.requireAmaD14 && item.requireAmaD14 === "Mandatory") {
        try {
          const selectedParticipants = this.participantsSel.filter(p => p.selected);
          this.requireAmaD14Dialog = this.amaDialog = await this.validateAmaGeneric(selectedParticipants, this.amaD14Data.organizationName || 'AMA-D14', item, 'D14');
          if (this.requireAmaD14Dialog) { this.loading = false; return; }
        } catch (error) {
          this.loading = false;
          this.$emit('alertNotValidate', this.$t('registerEvent.error_occurred'));
        }
      }

      // Check AMA
      if(item.requireAma && item.requireAma === "Mandatory"){
      try {
        const selectedParticipants = this.participantsSel.filter(p => p.selected);
          this.requireAmaDialog = this.amaDialog = await this.validateAmaGeneric(selectedParticipants, 'AMA', item, 'AMA');
          if(this.requireAmaDialog) {this.loading = false; return;}
      } catch (error) {
          this.loading = false;
        this.$emit('alertNotValidate', this.$t('registerEvent.error_occurred'));
      }
      } else if ((item.requireAma && item.requireAma === "Optional") || (item.requireAmaD14 && item.requireAmaD14 === "Optional")) {
        // Optional AMA/D14 Flow (Quiet Sync):
        // If AMA is optional OR D14 is optional, we check if the user already has an AMA membership on file.
        // If they do, we fire off a background (quiet) call to the D14 API using their AMA number.
        // This ensures D14 is kept in sync even when not strictly required, without blocking the user.
        try {
          const selectedParticipants = this.participantsSel.filter(p => p.selected);
          for (const participant of selectedParticipants) {
            this._dbLog('checking AMA for optional flow userId=' + participant.userId);
            AMAService.getAMAbyUserId(participant.userId, this.amaId || 25).then(resp => {
              const amaRecords = resp?.data?.message ?? [];
              this._dbLog('optional flow amaRecords length=' + amaRecords.length);
              if (amaRecords.length > 0) {
                this.quietlyAddD14Membership(participant, amaRecords[0].memberId);
              }
            }).catch((err) => {
              this._dbLog('optional flow AMA check error: ' + (err?.message || err));
            });
          }
        } catch (error) {
          // Quietly ignore
        }
      }

      try {        
            // Check if registration is already done in a non-multi registration event
            if (item.isMultiReg === 0 && participants.length > 0) {
              const isDoneRegistered = participants.some(participant => 
                participant.status.toLowerCase() === 'already registered' && participant.selected
              );
              if (isDoneRegistered) {
                this.$emit('alertNotValidate', this.$t('registerEvent.event_registration_part_done'));
            return;
              }
            }

            // Verify the registration date with the backend service
            const resp = await RegistrationService.verifyRegistrationDate(item.id);
        if (!resp.data.success) {
          throw new Error("Failed to verify registration date");
        }

        this.$emit('refreshHeader', resp.data.message);

            // Handle date manipulations using moment.js
        const now = moment();
        const tz = moment.tz.guess();
            const regOpen = moment(resp.data.message.registrationOpen).tz('America/New_York', true).tz(tz);
            const regClose = moment(resp.data.message.registrationClose).tz('America/New_York', true).tz(tz);

            // Format and store the dates in the registration object
            this.registrationObj.eventSel.regOpen = regOpen.format("YYYY-MM-DD HH:mm:ss");
            this.registrationObj.eventSel.regClose = regClose.format("YYYY-MM-DD HH:mm:ss");
            this.registrationObj.eventSel.nowDate = now.format("YYYY-MM-DD HH:mm:ss");
        this.displayModalWaiver = false;

            // Determine the current registration state based on the date comparison
            if (now.isBefore(regOpen)) {
              this.handleRegistrationState('soon', 'registerEvent.refresh_registration_date');
            } else if (now.isBetween(regOpen, regClose)) {
              await this.handleCurrentRegistration();
            } else {
              this.handleRegistrationState('close', 'registerEvent.event_registration_close');
            }

          } catch (error) {
        this.$emit('alertNotValidate', this.$t('registerEvent.error_occurred'));
          } finally {
        this.loading = false;
          }
    },
    /**
     * Handles the registration state and emits appropriate alerts based on the state.
     *
     * @param {string} type - The type of registration state (e.g., 'soon', 'close').
     * @param {string} alertMessage - The translation key for the alert message to be emitted.
     */
    handleRegistrationState(type, alertMessage) {
      this.registrationObj.eventSel.type = type; // Set the event type
      this.past = 9999999; // Arbitrary value for internal use
      this.$emit('alertNotValidate', this.$t(alertMessage)); // Emit the alert to notify the user
      this.tab = 0; // Reset the tab to the first one
    },
    /**
     * Handles the current registration state and verifies with the backend service.
     *
     * This function checks if the registration is currently valid by calling the backend
     * and emits events based on the verification result.
     */
    async handleCurrentRegistration() {
      try {
        const resp = await RegistrationService.getVerify(this.registrationObj.eventSel.id);

        if (resp.data.message) {
          this.$emit('validateRiders'); // Emit event to continue rider validation
        } else {
          // Close the registration if the server indicates it's no longer open
          this.registrationObj.eventSel.type = 'close';
          this.registrationObj.eventSel.displayRegistrationFlag = 0;
          this.$emit('alertNotValidate', this.$t('registerEvent.event_registration_close_server'));
          this.tab = 0; // Reset the tab to the first one
        }
      } catch (error) {
        this.$emit('alertNotValidate', this.$t('registerEvent.error_occurred'));
      } finally {
        const now = moment(); // Current time
        //const regOpen = moment(this.registrationObj.eventSel.regOpen);
        const regClose = moment(this.registrationObj.eventSel.regClose);

        if (now.isAfter(regClose)) {
          this.registrationObj.eventSel.type = 'close';
          this.past = 9999999;
          this.$emit('alertNotValidate', this.$t('registerEvent.event_registration_close'));
          this.tab = 0;
        }

        this.loading = false; // Ensure the loading indicator is turned off
      }
    },

    changeTab(newValue)
    {
      this.tab = newValue;
    },
    addRider()
    {
      LocalStorageService.setItem("link_back_spect", this.$route.name);
      LocalStorageService.setItem("add_part_reg_legacy", 1);
      LocalStorageService.setItem('active_event_registration', true);
      this.$router.push({
        path: "ridersCreate"
      });
    },
    addEmergencyContact()
    {
      LocalStorageService.setItem('active_event_registration', true);
      this.$router.push({
        path: 'emergencycontact'
      });
    },
    addMembership() {
      const eventId = this.registrationObj.eventSel.id;
      LocalStorageService.setItem('active_event_registration', true);
      this.registrationObjLocal.participants = this.registrationObj.participants;
      this.registrationObjLocal.partsSel = this.registrationObj.partsSel;
      
      if (eventId) {        
        OrganizationService.getOrganizationByEventId(eventId).then((resp) => {
          if (resp.data.success) {
            if (resp.data.message && resp.data.message.allowPublicView) {
              this.registrationObjLocal.organization = resp.data.message;
              this.registrationObjLocal.step = 2;
              LocalStorageService.setItem("member_reg", this.registrationObjLocal);
              this.$router.push({
                path: 'memberRegistration'
              });
            } else {
              this.$emit('alertNotValidate', this.$t('registerEvent.registration_not_available'));
            }
          }
        });
      } else {
        LocalStorageService.setItem("member_reg", this.registrationObjLocal);
        this.registrationObjLocal.step = 1;
        this.$router.push({
          path: 'memberRegistration'
        });
      }
    },
    updateCheck(newValue, id)
    {
      this.$emit('updateParticipants', { newValue, id });
    },
    updateAllChecks(newValue) {
      const eneabledParticipants = this.participantsSel.filter(item => !item.disabled && !item.disabledStatus);
      if(eneabledParticipants.length > 0)
      {
        eneabledParticipants
        .map(item => item.userId)
        .forEach(id => {
            this.updateCheck(newValue, id);
        })
      }
    },

    rowClass(item) {
      let rowClass = "";
      if (item.disabled || item.disabledStatus)
        rowClass = "grayC";
      return rowClass;
    },
    addSignedEventWaiver()
    {
      let _selected = (Array.isArray(this.participantsSel) ? this.participantsSel.filter(x => x.selected) : []);
      let band = false;
      let bandMsg = false;
      let bandReview = false;
      if (_selected.length > 0)
      {
        for (let i = 0; i < _selected.length; i++)
        {
          if (_selected[i].eventWaiverCode == "NotSigned" || _selected[i].eventWaiverCode == "Not Signed" || _selected[i].eventWaiverCode == "Rejected")
          {
            bandReview = true;
          }
          const birthday = Object.prototype.hasOwnProperty.call(_selected[i],'birthdayString') ? _selected[i].birthdayString : _selected[i].birthday;
          if (
            (_selected[i].eventWaiverCode == "NotSigned" || _selected[i].eventWaiverCode == "Not Signed" || _selected[i].eventWaiverCode == "Rejected") &&
            this.age18Calculate(birthday) && this.userStore.id != _selected[i].userId
          )
          {
            band = true;
          }
          if ((!_selected[i].eventWaiver) && !this.age18Calculate(birthday))
          {
            bandMsg = true;
          }
        }
      } else
      {
        band = true;
      }
      if (!bandReview && bandMsg)
      {
        this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_not_signed_alert'));
        return;
      }
      if (!band)
      {
        this.selectedSigWaiver = _selected;
        this.waiverEArray = [];
        this.resetWaiver = false;
        this.$store.commit('setOverlay', true);
        let bandOverlay = false;
        let selectedNotSigned = _selected.filter((el) => el.eventWaiver == 'NotSigned' || el.eventWaiver == 'Not Signed' || el.eventWaiver == 'Rejected');
        if (selectedNotSigned.length > 0)
        {
          _selected.forEach(async (item, i) =>
          {
            if (item.eventWaiverCode == "NotSigned" || item.eventWaiverCode == "Not Signed" || item.eventWaiverCode == "Rejected")
            {
              bandOverlay = true;
              let userId = item.userId;
              await this.generateWaiver(this.role, userId);
            }
            if (i == (_selected.length - 1) && !bandOverlay)
            {
              this.$store.commit('setOverlay', false);
            }
          });
        } else
        {
          this.$store.commit('setOverlay', false);
          this.$emit('alertNotValidate', this.$t("eventWaiver.not_waiver_signed"));
        }
      } else
      {
        LocalStorageService.setItem("link_back_event_waiver", this.$route.name);
        LocalStorageService.setItem("typeStep", this.role);
        LocalStorageService.setItem('active_event_registration', true);
        this.$emit("openmenu", "events");
        this.$router.push({
          path: "EventWaiverCreate",
          query: { eventId: this.registrationObj.eventSel.id }
        });
      }
    },
    age18Calculate(birthdayCurrent)
    {
      const nowDay = new Date();
      nowDay.setFullYear(nowDay.getFullYear() - this.ageAdult);
      if (birthdayCurrent)
      {
        const birthday = new Date(birthdayCurrent);
        return birthday <= nowDay;
      }
      return false;
    },
    async getEventWaivers(participant)
    {
      this.waiverDialogType = 'event';
      const trace = this.createWaiverTrace('event', participant);
      this.itemSelected = participant;
      const selectedBirthday = Object.prototype.hasOwnProperty.call(participant, 'birthdayString')
        ? participant.birthdayString
        : participant.birthday;
      this.itemSelectedIsMinor = selectedBirthday ? !this.age18Calculate(selectedBirthday) : null;

      let waiverData = {
        eventId: this.registrationObj.eventSel.id,
        userId: participant.userId,
        role: this.role,
        promoterId: this.registrationObj.promoterSel.promoterId
      };
      this.$store.dispatch('SET_WAIVER_DATA_ACTION', waiverData);
      this.itemSelected = participant;
      let eventID = this.registrationObj.eventSel.id;
      let data = {
        eventsId: [
          {
            id: eventID,
            usersId: [
              {
                id: participant.userId,
                roles: [this.role]
              }
            ]
          }
        ]
      };
      this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', []);
      this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_RAW_ACTION', []);
      this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_BY_RIDER_ACTION', {});

      let response = await EventWaiverService.getWaiversForUser(data);

      if (response.data.success)
      {
        const roleData = response.data.message[0].usersId[0].roles.find((el) =>
        {
          return el.userRoleCode == this.role;
        });
        const waiversRaw = roleData && Array.isArray(roleData.waivers) ? roleData.waivers : [];
        let waiversUser = waiversRaw.map((el) =>
        {
          let waiverTranslate = {};
          this.languages.forEach((language) =>
          {
            waiverTranslate[language.value] = false;
          });
          if (el.waiverTranslate.length > 0)
          {
            waiverTranslate.first = el.waiverTranslate[0];
          }
          el.waiverTranslate.forEach((itemTranslate) =>
          {
            waiverTranslate[itemTranslate.languageCode] = itemTranslate;
          });
          const birthday = Object.prototype.hasOwnProperty.call(participant,'birthdayString') ? participant.birthdayString : participant.birthday;
          return {
            ...el.waiverData,
            waiverTranslate,
            waiverstatus: el.status,
            userId: participant.userId,
            racerUserId: participant.userId,
            fullName: `${participant.fName} ${participant.lName}`,
            participantEmail: participant.email || participant.emailAddress || '',
            age18: this.age18Calculate(birthday),
            isMembershipWaiver: false,
            sourceColumn: 'eventWaiver',
            _traceId: trace.traceId
          };
        });
        this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', waiversUser);
        const hasPendingWaivers = waiversUser.some((waiver) =>
        {
          return waiver.waiverstatus == 'NotSigned' || waiver.waiverstatus == 'Rejected';
        });
        if (!hasPendingWaivers)
        {
          this.emitWaiverRefresh();
        }
        this.waiverRequiredDialog = true;
      } else
      {
        this.$emit('alertNotValidate', this.$t('common.error_general'));
      }
    },
    /**
     * Issue #116: end-to-end minor membership-waiver path.
     *
     * 1. Fetch the list of pending membership-waiver template rows for
     *    every selected participant and pick out the rows flagged as
     *    `isMinor`. Using `row.isMinor` from the backend is more
     *    reliable than computing the age client-side from
     *    `participant.birthday`, which is not always populated on
     *    `partSel`.
     * 2. Open `ParentGuardianDialog` once per distinct minor and cache
     *    the relationship in `parentGuardianByMinor`.
     * 3. Call `MembershipWaiverService.generateByMembershipWaiverId`
     *    per minor row with `legalGuardianAnswer: 'yes'` and the picked
     *    `signatoryRelationship`. The generated waiver record is
     *    pushed into `membershipWaiverEArray` so the existing watcher
     *    opens the `WaiverOrg` signing dialog for the actual signature.
     *
     * Returns one of:
     *   - 'completed' — signing UI queued, or every minor row failed to
     *      generate (in which case an actionable error alert is shown).
     *      In both cases the caller must NOT fall back to the legacy
     *      empty MembershipWaiverDialog.
     *   - 'blocked'   — user picked "Other" or the dialog was already
     *      gated. Caller bails with `loading = false`.
     *   - 'no-minors' — no minor waivers in the fetched rows. Caller
     *      falls through to the existing adult-only flow.
     */
    async handleMinorMembershipWaivers(missingWaivers) {
      try {
        const adultId = Number((this.userStore && this.userStore.id) || 0);
        if (!adultId) {
          return 'no-minors';
        }

        const eventId = Number(this.registrationObj?.eventSel?.id || 0);
        if (!eventId) {
          return 'no-minors';
        }

        const participantsForApi = missingWaivers.map((participant) => ({
          userId: Number(participant.userId),
          birthday: participant.birthdayString || participant.birthday || null,
          fName: participant.fName || participant.firstName || '',
          lName: participant.lName || participant.lastName || ''
        })).filter((p) => p.userId > 0);
        if (participantsForApi.length === 0) {
          return 'no-minors';
        }

        const participantIds = participantsForApi.map((p) => p.userId);
        const requestData = { eventId, usersId: participantIds };
        const defaultOrganizationId = Number(
          this.registrationObj?.eventSel?.organizationId ||
          this.registrationObj?.eventSel?.fkOrganizationId ||
          this.registrationObj?.eventSel?.organizationID ||
          0
        );
        if (defaultOrganizationId > 0) {
          requestData.defaultOrganizationId = defaultOrganizationId;
        }

        let allWaivers = [];
        try {
          const response = await MembershipWaiverService.getMembershipWaiversList(requestData);
          const succeeded = Array.isArray(response?.data) || response?.data?.success === 1;
          if (!succeeded) {
            return 'no-minors';
          }
          allWaivers = this.getMembershipRowsFromResponse(response);
        } catch (error) {
          return 'no-minors';
        }

        const minorWaiversByUser = new Map();
        const needsAdditionalSignatures = [];
        for (const w of allWaivers) {
          const userId = Number(w.participantId || w.fkUserId || w.userId || 0);
          if (!userId || userId === adultId) continue;
          const hasMinorFlag = w.isMinor !== undefined && w.isMinor !== null && `${w.isMinor}` !== '';
          let isMinor = hasMinorFlag ? Number(w.isMinor) === 1 : false;
          if (!isMinor && w.age18 === false) isMinor = true;
          if (!isMinor) {
            const participantBirthday = (participantsForApi.find((p) => p.userId === userId) || {}).birthday;
            if (participantBirthday) isMinor = !this.age18Calculate(participantBirthday);
          }
          if (!isMinor) continue;
          if (w.allSignaturesComplete === true) continue;
          const statusRaw = (w.waiverStatus || w.status || '').toString().trim().toLowerCase();
          const isSigned = statusRaw === 'signed' || statusRaw === '2' || statusRaw === '4';
          const required = Number(w.signaturesRequired || w.qtSignReq || w.required || 1);
          if (isSigned && required > 1) {
            needsAdditionalSignatures.push({ ...w, userId });
            continue;
          }
          if (isSigned) continue;
          if (!minorWaiversByUser.has(userId)) {
            minorWaiversByUser.set(userId, []);
          }
          minorWaiversByUser.get(userId).push(w);
        }

        if (minorWaiversByUser.size === 0 && needsAdditionalSignatures.length > 0) {
          await this.getMembershipWaivers(missingWaivers[0], missingWaivers);
          return 'completed';
        }
        if (minorWaiversByUser.size === 0) {
          return 'no-minors';
        }

        if (this._relationshipResolver) {
          return 'blocked';
        }

        for (const [userId, userWaivers] of minorWaiversByUser.entries()) {
          if (this.blockedMinorIds.includes(userId)) {
            return 'blocked';
          }
          const cached = this.parentGuardianByMinor[userId];
          if (cached && cached !== 'Other') {
            continue;
          }
          const w0 = userWaivers[0] || {};
          const fromParticipant = participantsForApi.find((p) => p.userId === userId) || {};
          const minor = {
            id: userId,
            fName: w0.participantName || w0.firstName || w0.fName || fromParticipant.fName || '',
            lName: w0.participantLastname || w0.lastName || w0.lName || fromParticipant.lName || ''
          };
          this.parentGuardianDialogMinor = minor;
          this.parentGuardianDialogOpen = true;
          const result = await new Promise((resolve) => {
            this._relationshipResolver = resolve;
          });
          this._relationshipResolver = null;
          if (!result || result.blocked) return 'blocked';
          this.parentGuardianByMinor = {
            ...this.parentGuardianByMinor,
            [userId]: result.relationshipCode
          };
        }

        let attempted = 0;
        let queued = 0;
        const failures = [];

        for (const [userId, userWaivers] of minorWaiversByUser.entries()) {
          const relationship = this.parentGuardianByMinor[userId];
          if (!relationship || relationship === 'Other') continue;
          for (const w of userWaivers) {
            attempted += 1;
            const fkOrganizationDocumentId = Number(w.fkOrganizationDocumentId || w.membershipWaiverTemplateId || 0);
            if (!fkOrganizationDocumentId) {
              continue;
            }
            if (w.id) {
              this.addMembershipWaiver({ ...w, fkUserId: userId, userId, signatoryRelationship: relationship });
              queued += 1;
              continue;
            }
            const signatoryEmail = ((this.userStore && (this.userStore.emailAddress || this.userStore.email)) || '') || null;
            const payload = {
              membershipWaiverId: fkOrganizationDocumentId,
              userId,
              eventId,
              organizationId: w.organizationId || null,
              requestedByUserId: adultId,
              signatoryEmail,
              signatoryRelationship: relationship,
              legalGuardianAnswer: 'yes'
            };
            try {
              const resp = await MembershipWaiverService.generateByMembershipWaiverId(payload);
              if (resp && resp.data && resp.data.success === 1 && resp.data.message && resp.data.message.id) {
                const generated = resp.data.message;
                const normalized = {
                  ...w,
                  ...generated,
                  fkUserId: userId,
                  userId,
                  signatoryRelationship: relationship
                };
                this.addMembershipWaiver(normalized);
                queued += 1;
              } else {
                failures.push({ userId, fkOrganizationDocumentId, message: resp && resp.data && resp.data.message });
              }
            } catch (error) {
              failures.push({ userId, fkOrganizationDocumentId, message: (error && error.message) || 'exception' });
            }
          }
        }

        if (queued > 0) {
          try {
            await this.handleRefreshMembershipWaiverStatus();
          } catch (error) {
            // Keep going — waiver records were queued successfully
          }
          return 'completed';
        }

        if (attempted > 0) {
          this.$emit('alertNotValidate', this.$t('registerEvent.membership_waiver_generation_failed'));
        }
        return 'completed';
      } finally {
        // cleanup
      }
    },
    /**
     * Legacy gate retained for any caller not yet routed through
     * `handleMinorMembershipWaivers`. New flows should call the
     * combined handler above.
     */
    async ensureRelationshipsForMinorParticipants(missingWaivers) {
      // Issue #116 review: refuse re-entry while a previous resolver is
      // still pending so a double click on Next or a re-fired guard
      // can't overwrite `_relationshipResolver` and leave the prior
      // promise hanging. Bail returns false → caller resets `loading`.
      if (this._relationshipResolver) return false;
      const adultId = Number((this.userStore && this.userStore.id) || 0);
      if (!adultId) return true;
      const uniqueMinors = new Map();
      for (const participant of missingWaivers) {
        const id = Number(participant && participant.userId);
        if (!id || id === adultId) continue;
        const birthday = Object.prototype.hasOwnProperty.call(participant, 'birthdayString')
          ? participant.birthdayString
          : participant.birthday;
        const isMinor = birthday ? !this.age18Calculate(birthday) : false;
        if (!isMinor) continue;
        if (!uniqueMinors.has(id)) {
          uniqueMinors.set(id, {
            id,
            fName: participant.fName || participant.firstName || '',
            lName: participant.lName || participant.lastName || ''
          });
        }
      }
      if (uniqueMinors.size === 0) return true;
      for (const minor of uniqueMinors.values()) {
        if (this.blockedMinorIds.includes(minor.id)) return false;
        const existing = this.parentGuardianByMinor[minor.id];
        if (existing && existing !== 'Other') continue;
        this.parentGuardianDialogMinor = minor;
        this.parentGuardianDialogOpen = true;
        const result = await new Promise(resolve => {
          this._relationshipResolver = resolve;
        });
        this._relationshipResolver = null;
        if (!result || result.blocked) return false;
        this.parentGuardianByMinor = {
          ...this.parentGuardianByMinor,
          [minor.id]: result.relationshipCode
        };
      }
      return true;
    },
    onParentGuardianConfirmed(payload) {
      if (this._relationshipResolver) {
        this._relationshipResolver({ blocked: false, relationshipCode: payload && payload.relationshipCode });
      }
    },
    onParentGuardianBlocked(payload) {
      if (payload && payload.minor && payload.minor.id) {
        this.blockedMinorIds.push(Number(payload.minor.id));
      }
      this.$emit('alertNotValidate', this.$t('memberRegistration.parent_guardian.blocked_message'));
      if (this._relationshipResolver) {
        this._relationshipResolver({ blocked: true, relationshipCode: 'Other' });
      }
    },
    /**
     * Issue #116: For each selected minor with a confirmed (non-Other)
     * relationship, fetch the org/membership waiver templates that need
     * signing and call MembershipWaiverService.generateByMembershipWaiverId
     * with `legalGuardianAnswer: 'yes'` and the picked
     * `signatoryRelationship`. Each generated waiver is pushed into
     * `membershipWaiverEArray`, whose watcher opens the WaiverOrg signing
     * dialog. Returns true when at least one minor waiver was queued so
     * the caller can short-circuit the old MembershipWaiverDialog path.
     */
    async generateMinorMembershipWaiversWithRelationship(missingWaivers) {
      const adultId = Number((this.userStore && this.userStore.id) || 0);
      if (!adultId) return false;
      const minorParticipantsMap = new Map();
      for (const participant of missingWaivers) {
        const id = Number(participant && participant.userId);
        if (!id || id === adultId) continue;
        const relationship = this.parentGuardianByMinor[id];
        if (!relationship || relationship === 'Other') continue;
        if (!minorParticipantsMap.has(id)) {
          minorParticipantsMap.set(id, participant);
        }
      }
      if (minorParticipantsMap.size === 0) return false;

      const currentEventId = Number((this.registrationObj && this.registrationObj.eventSel && this.registrationObj.eventSel.id) || 0);
      const eventSel = (this.registrationObj && this.registrationObj.eventSel) || {};
      const defaultOrganizationId = Number(
        eventSel.organizationId ||
        eventSel.fkOrganizationId ||
        eventSel.organizationID ||
        0
      );
      const usersId = Array.from(minorParticipantsMap.keys());
      const requestData = {
        eventId: currentEventId > 0 ? currentEventId : undefined,
        usersId
      };
      if (defaultOrganizationId > 0) {
        requestData.defaultOrganizationId = defaultOrganizationId;
      }

      let rows = [];
      try {
        await this.prepareMembershipWaiversForUsers(usersId);
        const fetched = await this.fetchMembershipWaiverRowsWithFallback(requestData, 'parent-guardian-gate');
        rows = Array.isArray(fetched && fetched.rows) ? fetched.rows : [];
      } catch (error) {
        return false;
      }

      const requestedByUserId = adultId;
      const signatoryEmail = ((this.userStore && (this.userStore.emailAddress || this.userStore.email)) || '') || null;
      let queued = 0;

      for (const row of rows) {
        const userId = Number(row.userId || row.racerUserId || row.participantUserId || row.riderUserId || 0);
        if (!minorParticipantsMap.has(userId)) continue;
        const statusRaw = (row.waiverStatus || row.status || '').toString().trim().toLowerCase();
        if (statusRaw === 'signed' || statusRaw === '2' || statusRaw === '4') continue;
        const membershipWaiverId = Number(
          row.membershipWaiverTemplateId ||
          row.fkWaiverId ||
          row.waiverId ||
          row.templateWaiverId ||
          row.id ||
          0
        );
        if (!membershipWaiverId) continue;
        const relationship = this.parentGuardianByMinor[userId];
        const payload = {
          membershipWaiverId,
          userId,
          eventId: Number(row.eventId || row.fkEventId || row.eventsId || currentEventId || 0) || undefined,
          organizationId: row.organizationId || defaultOrganizationId || null,
          requestedByUserId,
          legalGuardianAnswer: 'yes',
          signatoryEmail,
          signatoryRelationship: relationship
        };
        try {
          const resp = await MembershipWaiverService.generateByMembershipWaiverId(payload);
          if (!resp || !resp.data || resp.data.success !== 1) continue;
          const message = resp.data.message || {};
          const action = (message.action || '').toString().toLowerCase();
          if (action === 'email_sent') continue;
          if (message && message.id) {
            const normalized = {
              ...message,
              fkUserId: message.fkUserId || userId,
              userId: message.userId || userId
            };
            this.addMembershipWaiver(normalized);
            queued += 1;
          }
        } catch (error) {
          // Skip this row; remaining rows still get a chance to generate.
        }
      }

      if (queued > 0) {
        try {
          await this.handleRefreshMembershipWaiverStatus();
        } catch (error) {
          // Refresh failure is non-fatal — the signing UI is already queued.
        }
      }
      return queued > 0;
    },
    async getMembershipWaivers(participant, scopeParticipants = null) {
      this.waiverDialogType = 'membership';
      const trace = this.createWaiverTrace('membership', participant);
      const scope = this.getMembershipWaiverScopeParticipants(participant, scopeParticipants);
      const dialogParticipant = participant || scope[0] || null;
      if (!dialogParticipant || scope.length === 0) {
        this.$emit('alertNotValidate', this.$t('common.error_general'));
        return;
      }
      this.itemSelected = dialogParticipant;
      const selectedBirthday = Object.prototype.hasOwnProperty.call(dialogParticipant, 'birthdayString')
        ? dialogParticipant.birthdayString
        : dialogParticipant.birthday;
      this.itemSelectedIsMinor = selectedBirthday ? !this.age18Calculate(selectedBirthday) : null;

      this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', []);
      this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_RAW_ACTION', []);
      this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_BY_RIDER_ACTION', {});

      const currentEventId = Number(this.registrationObj?.eventSel?.id);
      const defaultOrganizationId = Number(
        this.registrationObj?.eventSel?.organizationId ||
        this.registrationObj?.eventSel?.fkOrganizationId ||
        this.registrationObj?.eventSel?.organizationID ||
        0
      );
      const requestData = {
        eventId: currentEventId > 0 ? currentEventId : undefined,
        usersId: scope.map((row) => Number(row.userId)).filter((id) => id > 0)
      };
      if (defaultOrganizationId > 0) {
        requestData.defaultOrganizationId = defaultOrganizationId;
      }

      try {
        await this.prepareMembershipWaiversForUsers(requestData.usersId);
        const membershipFetch = await this.fetchMembershipWaiverRowsWithFallback(requestData, trace.traceId);
        const allRows = membershipFetch.rows;
        const scopedUserIds = new Set(requestData.usersId.map((id) => Number(id)));
        const getRowRiderUserId = (row) =>
          Number(
            row?.userId ||
            row?.racerUserId ||
            row?.participantUserId ||
            row?.riderUserId ||
            0
          );
        const scopedRows = allRows.filter((row) => scopedUserIds.has(getRowRiderUserId(row)));
        const waiversRows = scopedRows.filter((row) => {
          const rowEventId = Number(row.eventId || row.eventsId || row.fkEventId || row.membershipEventId || 0);
          if (rowEventId > 0 && currentEventId > 0 && rowEventId !== currentEventId) {
            return false;
          }
          return Number(row.required) === 1 || Number(row.qtSignReq) > 0 || Number(row.signaturesRequired) > 0;
        });
        const waiversUser = this.normalizeMembershipWaiversForDialog(waiversRows, scope, trace);

        const waiversByRider = waiversUser.reduce((acc, row) => {
          const key = String(row.userId);
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(row);
          return acc;
        }, {});
        this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_RAW_ACTION', allRows);
        this.$store.dispatch('SET_MEMBERSHIP_WAIVERS_BY_RIDER_ACTION', waiversByRider);
        this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', waiversUser);
        this.waiverRequiredDialog = true;
      } catch (error) {
        this.$emit('alertNotValidate', this.$t('common.error_general'));
      }
    },
    addWaiver(item)
    {
      this.waiverEArray.push(item);
    },
    addMembershipWaiver(item)
    {
      const locale = this.$i18n?.locale || "en";
      const selected = this.itemSelected || {};
      const contentByLocale = item?.content && typeof item.content === "object"
        ? (item.content[locale] || item.content.en || item.content.first || null)
        : null;
      const firstText = (...candidates) => {
        for (const value of candidates) {
          if (typeof value === "string" && value.trim().length > 0) {
            return value;
          }
        }
        return "";
      };
      const fallbackTitle =
        item?.displayName ||
        item?.membershipWaiverTitle ||
        item?.waiverName ||
        item?.nameWaiver ||
        item?.waiverTitle ||
        item?.title ||
        "";
      const normalized = {
        ...item,
        displayName: firstText(
          item?.displayName,
          contentByLocale?.title,
          item?.waiverTranslate?.[locale]?.title,
          item?.waiverTranslate?.first?.title,
          fallbackTitle
        ),
        documentMessage: firstText(
          item?.documentMessage,
          contentByLocale?.documentMessage,
          contentByLocale?.liabilityWaiverMessage,
          contentByLocale?.waiverMessage,
          contentByLocale?.content,
          contentByLocale?.body
        ),
        electronicConsent: firstText(
          item?.electronicConsent,
          contentByLocale?.electronicConsent,
          contentByLocale?.electronicSignatureConsent,
          contentByLocale?.consentMessage
        ),
        participantName: item?.participantName || selected?.fName || "",
        participantLastname: item?.participantLastname || selected?.lName || "",
        participantEmail: item?.participantEmail || selected?.emailAddress || selected?.email || "",
        participantGender: item?.participantGender || selected?.gender || "",
        participantDateOfBirth: item?.participantDateOfBirth || selected?.birthdayString || selected?.birthday || null,
        isAgreedChk: item?.isAgreedChk || null,
        isCertifyChk: item?.isCertifyChk || null,
        isElectronicConsentChk: item?.isElectronicConsentChk || null,
        languageCode: item?.languageCode || locale
      };
      this.membershipWaiverEArray.push(normalized);
    },
    changeField({ field, value })
    {
      this[field] = value;
    },
    scrollWaiverDialogTop()
    {
      this.$nextTick(() =>
      {
        const overlays = document.querySelectorAll('.v-dialog--active');
        overlays.forEach((el) => { el.scrollTop = 0; });
        if (typeof window !== 'undefined' && typeof window.scrollTo === 'function')
        {
          window.scrollTo(0, 0);
        }
      });
    }
  },
  created()
  {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.key++;

    this.getOrganizations();
  },
  mounted()
  {
    let registration = LocalStorageService.getItem("registration_legacy");
    if (LocalStorageService.getItem("reload") >= 1 && (registration && registration.step == this.stepperCounts))
    {
      LocalStorageService.setItem("reload", 0);
      this.$emit('nextStep', this.stepperCounts);
    }
    LocalStorageService.setItem("reload", LocalStorageService.getItem("reload") + 1);    
    this.getOrganizationsAvailableForAma();
    this.getAMAD14();
    this.getAMAId();
  },
  watch: {
    step()
    {
      this.tab = 0;
    },
    partSel: {
      immediate: true,
      handler(selectedParticipants){
        if(!selectedParticipants || !this.registrationObj) return;

        const participants = Array.isArray(this.registrationObj.participants) ? this.registrationObj.participants : [];
        const numDisabledParticipants = participants.filter(obj => obj.disabled || obj.disabledStatus).length;

        if(selectedParticipants.length < (participants.length - numDisabledParticipants))
        {
          this.allCheck = false;
        }

        this.queueInitialMembershipWaiverStatusRefresh(selectedParticipants);
      }
    },
    participantsSel: {
      immediate: true,
      handler(visibleParticipants) {
        this.queueInitialMembershipWaiverStatusRefresh(visibleParticipants);
      }
    },
    waiverEArray(val) {
      if (Array.isArray(val) && val.length > 0) {
        let valUsersID = val.find((el) => { return el.fkUserId == this.userStore.id });
        this.waiverE = val[0].fkUserId == this.userStore.id ? val[0] : (valUsersID ? valUsersID : val[0]);
        if (!this.resetWaiver)
        {
          this.resetWaiver = true;
          this.waiverModal = true;
          if (this.$refs.waiverEvent)
          {
            this.$refs.waiverEvent.$refs.waiverYou.$refs.formWaiver.resetValidation();
          }
          this.scrollWaiverDialogTop();
        } else
        {
          setTimeout(() =>
          {
            this.waiverModal = true;
            if (this.$refs.waiverEvent)
            {
              this.$refs.waiverEvent.$refs.waiverYou.$refs.formWaiver.resetValidation();
            }
            this.scrollWaiverDialogTop();
          }, 1000);
        }
      }
    },
    membershipWaiverEArray(val) {
      if (Array.isArray(val) && val.length > 0) {
        let valUsersID = val.find((el) => { return el.fkUserId == this.userStore.id });
        this.membershipWaiverE = val[0].fkUserId == this.userStore.id ? val[0] : (valUsersID ? valUsersID : val[0]);
        if (!this.resetMembershipWaiver)
        {
          this.resetMembershipWaiver = true;
          this.membershipWaiverModal = true;
          this.scrollWaiverDialogTop();
        } else
        {
          setTimeout(() =>
          {
            this.membershipWaiverModal = true;
            this.scrollWaiverDialogTop();
          }, 1000);
        }
      }
    },
    waiverModal(val)
    {
      if (!val)
      {
       /* setTimeout(() =>
        {
          if (this.$refs.waiverModalParticipant) this.$refs.waiverModalParticipant.$el.scrollIntoView();
        }, 200);*/
      }
    },
    membershipWaiverModal(val)
    {
      if (!val)
      {
        setTimeout(() =>
        {
          if (this.$refs.membershipWaiverModalParticipant) this.$refs.membershipWaiverModalParticipant.$el.scrollIntoView();
        }, 200);
      }
    },
    waiverRequiredDialog(val)
    {
      if (!val)
      {
        if (this.itemSelected)
        {
          this.bSendWaiver = false;
          this.resetWaiver = false;
          this.$store.commit('setOverlay', false);
        }
      }
    }
  }
}
</script>

<style lang="scss">
.dt_part {
  tr.actions-header > th {
    border-bottom: 0px !important;
    padding-bottom: 5px;
    
    .primary--text {
      color: #555 !important;
      caret-color: #fff !important;
    }
  }
}

</style>

<style>
@media (max-width: 960px) {
  .next1 {
    display: block;
  }

  .next2Part {
    display: none;
  }
}

@media (min-width: 960px) {
  .next1 {
    display: none;
  }

  .next2Part {
    display: block;
  }
}
</style>
<style scoped>
.error-question-circle-button {
  background-color: #ff000000 !important;
  border: 0px !important;
  box-shadow: none !important;
}

.error-question-circle-button i {
  color: #6f6f6f !important;
}

.error-question-circle-button i:hover {
  color: #2f2f2f !important;
}
.text-danger {
  color: #ff0000 !important;
}
.error-message {
  font-size: 14px;
}
.title_card{
  word-wrap: break-word;
  word-break: break-word;
  padding-bottom: 2px !important;
}
.subtitle_card{
  word-wrap: break-word;
  word-break: break-word;
  font-size: 12px;
  color: #666;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
.new_card{
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin-bottom: 5px;
}
.card_new_items{
  overflow-y: auto;
  max-height: 250px;
}
.error_msg{
  color: #FFFFFF;
  background-color: #ff0000;
  padding: 2px 4px
}
.warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  padding: 12px;
  border-radius: 6px;
}
.warning-icon {
  font-size: 20px;
  line-height: 1;
}
.btn-responsive {
  text-transform: none;
}
@media (max-width: 599px) {
  .btn-responsive {
    height: auto !important;
    min-height: 36px;
    padding: 8px 12px !important;
    max-width: 100%;
    width: 100%;
  }
}
@media (max-width: 600px) {
  .subtitle_card{
    line-height: 1;
  }
  .new_card span{
    font-size: 12px;
  }
  .card_new_items{
    max-height: 250px;
  }
  .org-name{
    font-size: 13px;
  }
}
</style>
